const __COMMAN = "https://parker.fun4club.com/Api/"

const commonURI = {
    _LiveJsonRate: "https://bts.onex99.com/api/Admin/GetAllBrodCC",
    _LiveJsonRate_New: "https://nodebb.9xxbet.com/api/file/broadcast",
    _LiveJsonRate2: "https://nodebb.9xxbet.com/api/broadcast",
    _LiveJsonRateHorse: "https://servmastereve.omexch.co/api/admin/GetHorseBB",
    _MasterJson: "",
    // __MASTERREQUESTJSON_URL: "https://bts.onex99.com/api/Admin/GetMasterCOMEV",
    __MASTERREQUESTJSON_URL: "https://nodebb.9xxbet.com/api/master/getwholemasterfancy",
    // __MASTERREQUESTJSON_URL: "https://bts.onex99.com/api/Admin/GetMaster",
    __MASTERREQUESTJSON_URL_TEST: "https://bts.onex99.com/api/Admin/GetMastertest",
    __MASTERREQUESTJSON_URL_INPLAY: "https://nodebb.9xxbet.com/api/file/getMaster?sportsId=-1&marketType=MATCH_ODDS",
    __MASTERREQUESTJSON_URL_Cricket: "https://nodebb.9xxbet.com/api/file/getMaster?sportsId=4&marketType=MATCH_ODDS",
    __MASTERREQUESTJSON_URL_Soccer: "https://nodebb.9xxbet.com/api/file/getMaster?sportsId=1&marketType=MATCH_ODDS",
    __MASTERREQUESTJSON_URL_Soccer_New: "https://nodd.9xxbet.com/api/broadcast",
    __MASTERREQUESTJSON_URL_Tennis: "https://nodebb.9xxbet.com/api/file/getMaster?sportsId=2&marketType=MATCH_ODDS",
    __MASTERREQUESTJSON_URL_Winner: "https://nodebb.9xxbet.com/api/file/getMaster?sportsId=-2&marketType=WINNER",
    __MASTERREQUESTJSON_URL_Horse: "https://bts.onex99.com/api/Admin/GetMasterHorse",
    __MASTERREQUESTJSON_URL_HorseNew: "https://hmaster.omexch.co/master.json",
    __MASTERREQUESTJSON_URL_HorseNew2: "https://hmaster.omexch.co/Horsemaster.json",
    __MASTERREQUESTJSON_URL_Horse2: "https://mas.9xxbet.com/api/master/getHorseMaster?dt=",
    __MASTERREQUESTJSON_URL_Horse_C: "https://mas.9xxbet.com/api/master/getHorseMasterC?country=",
    __MASTERREQUESTJSON_URL_Event: "https://nodebb.9xxbet.com/api/file/getMaster?eventId=",
    __LIVE_SCORE_NEW_URL: "https://sportsscore.onupdate.in/#/",
    __LIVE_SCORE_URL: "https://score.appleexch.co/#/",
}

const fTradeApi = "https://orderapin.fun4club.com/api/admin/TestOrder";
const deleteTradeApi = "https://orderapin.fun4club.com/api/admin/DeleteOrder";

const __WebKeyUSER = "fhbrhevdnrer7gg08fdg7nf76f98bgb5df5g6f8bt6gf969n5ngfuy6sf8" // fun4club
// const __WebKeyUSER = "p9r6a89jOq32VGKJHsdf65gEDTk5iog5SFCv23srf56GBryp7a7rbd"
// const __WebKeyUSER = "hdghhgg4fjn8h4bv4b8gvcb5fc4b8gf78fgbg89b8fd9ib8fubvgmigutv"

const commonUriAll = {
    _LoginUrl: __COMMAN + "User/AuthenticateUniqueSECUREParkar",
    _BalanceApi: __COMMAN + "User/MyBalanceWithCreditChipsSECUREParker",
    _StatementApi: __COMMAN + "Data/UserAccounntAllStatementNew",
    _CasinoStatementApi: __COMMAN + "Data/EzugiTradeReportsParker",
    _LiveBetApi: __COMMAN + "Data/AllMatchedLiveRangeSECUREVV",
    _UnMatched_LiveBetApi: __COMMAN + "Data/UnMatchedLiveNewSECURE",
    _UnMatched_LiveBetApiNew: __COMMAN + "Data/UnMatchedLiveNewSECUREEvent",
    _UserLogoutApi: __COMMAN + "User/LogoutSECURE",
    _PopUpApi: __COMMAN + "Data/ChildProfitLossReportSECURE",
    _StackRangeSECURE: __COMMAN + "Admin/StackRangeSECURE",
    __WEBSOCKET_URL: "wss://wss.fun4club.com/api/stream",
    __M2MLiveSecure: __COMMAN + "Data/M2MLiveSECUREVV",
    __UnmatchedURL: __COMMAN + "Data/UnMatchedLiveNewSECURE",
    __M2MLiveSecureNew: __COMMAN + "Data/HomePLForAllSECURE",
    __MatchedURLhistory: __COMMAN + "Data/MatchedLiveSECUREAlldata",
    __GetUserExpozure: __COMMAN + "Data/GetUserExpoNew",
    __GetMatchedBetData: __COMMAN + "Data/MatchedHistoryByRangeReportSECURE",
    getLiveStreamsURL: __COMMAN + "Admin/TVSECURE",
    __TV_STREAM_URL: "https://orangeexch999.com/jmp/nm3/all.php?eventId=",
    CASINO_LOCK: __COMMAN + "Admin/CasinoLock",
    setEzugiCasinoURL: __COMMAN + "User/AddEzugiTokenSECURE",
    setLotusTokenURL: __COMMAN + "User/AddLotusTokenNewSECURE",
    __ADD_BALANCE_URL: __COMMAN + "Data/paymentDepositReqFlexExchSECURE",
    __WITHDRAW_BALANCE_URL: __COMMAN + "Flex/VxPHWO1ztzY4Haafrfwwcscssafsdsdsds343ssdasdssssssasdDvKoLOtC5XmuVLn",
    __REGISTER_OTP_URL: __COMMAN + "Giga/ZsdkeodksldfjAsKlwpLdkeAworpeMNaskeprldsjdj",
    __Register_SUBMIT_URL: __COMMAN + "Admin/ReferOnlineRegistrationKheloind",
    __GET_FILE_BANK_URL: __COMMAN + "flex/getBankImageKheloind",
    ChangePasswordSelfURL: __COMMAN + 'User/ChangeIdentitySECURE',
    GetTransactionsList_URL: __COMMAN + 'Flex/LOyMqlduipHwqL5sBx3QagE6qN9js0JBj7H3o7GN7lcQyO43t8PEs1HWI1XOaOqZSDY8dUVL6BWudOLQ',
    ClientProfitLossReportUrl: __COMMAN + "Data/PLCommRangeHistoryWithCountSECURE",
    __PL_MATCHEDHISTIRYNEW_URL: __COMMAN + "Data/MatchedHistoryByRangeReportSECURENew",
    // __Get_poster_3exch: __COMMAN + "flex/getallImages3exch",
    __Get_poster_3exch: "https://betapi.orange9.club/Api/Data/getImageOrange",
    __GETBANNERS_URL: "https://betapi.orange9.club/Api/Data/getImageOrange",
    __WEBSOCKET_URL_Casino: "wss://testwssn.fun4club.com/api/stream",
    __WEBSOCKET_URL_Old: "wss://pawss.fun4club.com/api/stream",
    __GETPOSTER_URL: __COMMAN + "flex/getallImageskheloind",
    _Casino_Live_Bets: __COMMAN + "Data/CasinoBetHistoryDiamond",
    __Session_Book: __COMMAN + "Data/M2MLiveSECURE",
    __Session_Deal: __COMMAN + "Data/MatchedLiveSECUREAlldata",
    _Casino_Last_10_Result: __COMMAN + "admin/CasinoResultbytable",
    _M2M_Casino_Diaomond: __COMMAN + "data/casinom2mdiamond",
    __Summery_Report: __COMMAN + "Data/PLCommRangeHistoryWithCountSECUREPARKARGroup",
    __Change_Password: __COMMAN + "User/passwordmatchtrue",
    __BroadCast_Msg_Api: __COMMAN + "Admin/getHyperNormalMessage",
    __Save_Stack_Setting: __COMMAN + "User/SaveStackSECURE",
    __Get_Stack_Btn: __COMMAN + "User/StackSECURE",
    __PL_History_report: __COMMAN + "Data/BetHistorySECUREparker",
    __PL_Common_Range_Report: __COMMAN + "Data/PLCommRangeHistoryWithCountSECUREParker",
    ChipSummaryReportURL: __COMMAN + "User/ChipSummaryReportNewSECURE",
    checkUserStatus: __COMMAN + "Admin/LoginStatus",
}

const __LOTUS_LOBBY = [
    {
        NAME: "3 Cards Judgement|L0O7T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67670.jpg",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Dream Catcher|L7O6T5U8S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/98567.jpg",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Super Over|L0O2T7U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67720.jpg",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Teen Patti One Day|L7O6T7U6S5S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/56767.jpg",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Roulette|L8O8T7U8S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/98788.jpg",
        GPP: "LROTLGPTP",
        catagory: "Roulette"
    },
    {
        NAME: "SicBo|L6O6T5U8S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/98566.jpg",
        GPP: "LSOTIGPCP",
        catagory: "Roulette"
    },
    {
        NAME: "Baccarat|L8O3T0U2S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/92038.jpg",
        GPP: "LBOTCGPTP",
        catagory: "Baccarat"
    },
    {
        NAME: "Andar Bahar|L4O6T6U7S8S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/87564.jpg",
        GPP: "LAOTBGPRP",
        catagory: "Andar Bahar"
    },
    {
        NAME: "Teen Patti T20|L8O6T7U6S5S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/56768.jpg",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "7 Up 7 Down|L9O8T7U8S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/98789.jpg",
        GPP: "LSOTUGPDP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Hi Low|L8O6T9U6S5S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/56968.jpg",
        GPP: "LHOTLGPWP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Dragon Tiger|L0O9T7U8S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/98790.jpg",
        GPP: "LDOTTGPRP",
        catagory: "Dragon"
    },
    {
        NAME: "2 Cards Teen Patti|L0O6T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67660.jpg",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Poker|L4O6T5U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67564.jpg",
        GPP: "LPOTKGPRP",
        catagory: "Poker"
    },
    {
        NAME: "Teen Patti Test|L0O3T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67630.jpg",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Bollywood Casino|L0O7T5U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67570.jpg",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "32 Cards Casino|L7O6T9U6S5S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/56967.jpg",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Queen|L0O2T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67620.jpg",
        GPP: "LROTCGPEP",
        catagory: "Queen"
    },
    {
        NAME: "Worli Matka|L7O3T0U2S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/92037.jpg",
        GPP: "LMOTTGPKP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Amar Akbar Anthony|L1O9T7U8S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/98791.jpg",
        GPP: "LAOTAGPAP",
        catagory: "Amar"
    },
    {
        NAME: "Race To 17|L0O1T7U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67710.jpg",
        GPP: "LROTCGPEP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Poker 20-20|L7O6T5U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67567.jpg",
        GPP: "LPOTKGPRP",
        catagory: "Poker"
    },
    {
        NAME: "Baccarat 29 Cards|L0O9T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67690.jpg",
        GPP: "LBOTCGPTP",
        catagory: "Baccarat"
    },
    {
        NAME: "Muflis Teen Patti|L0O0T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67600.jpg",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "The Trap|L0O8T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67680.jpg",
        GPP: "LROTCGPEP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Race 20-20|L0O0T1U0S9S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/90100.jpg",
        GPP: "LROTCGPEP",
        catagory: "Teenpatti"
    },
    {
        NAME: "6 Players Poker|L5O6T5U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67565.jpg",
        GPP: "Poker"
    },
    {
        NAME: "Casino Meter|L5O7T5U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67575.jpg",
        GPP: "Teenpatti"
    },
    {
        NAME: "Teen Patti Open|L0O4T6U7S6S",
        IMG: "https://d.fawk.app/assets/images/LeftSiteMenu/games/67640.jpg",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    /*============================================*/
    {
        NAME: "32 Cards Judgement|I0M2A7G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/3%20Cards%20Judgement.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Dream Catcher|I7M6A5G8ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Dream%20Catcher.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Super Over|I0M2A7G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Super%20Over.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Live Teen Patti|I7M6A7G6ES5",
        IMG: "https://d.fawk.app/assets/images/Games/Live%20Teenpatti.png",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Roulette|I8M8A7G8ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Roulette.png",
        GPP: "LROTLGPTP",
        catagory: "Roulette"
    },
    {
        NAME: "Sicbo|I6M6A5G8ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Sicbo.png",
        GPP: "LSOTIGPCP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Baccarat|I8M3A0G2ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Baccarat.png",
        GPP: "LBOTCGPTP",
        catagory: "Baccarat"
    },
    {
        NAME: "Andar Bahar|I4M6A5G7ES8",
        IMG: "https://d.fawk.app/assets/images/Games/Andar%20Bahar.png",
        GPP: "LAOTBGPRP",
        catagory: "Andar"
    },
    {
        NAME: "Teen Patti T-20|I8M6A7G6ES5",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20T20.png",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "7 Up 7 Down|I9M8A7G8ES9",
        IMG: "https://d.fawk.app/assets/images/Games/7%20up%20&%20Down.png",
        GPP: "LSOTUGPDP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Hi Low|I8M6A9G6ES5",
        IMG: "https://d.fawk.app/assets/images/Games/Hi%20Low.png",
        GPP: "LHOTLGPWP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Dragon Tiger|I0M9A7G8ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Dragon%20Tiger.png",
        GPP: "LDOTTGPRP",
        catagory: "Dragon"
    },
    {
        NAME: "2 Cards Teen Patti|I0M6A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/2%20Cards%20Teenpatti.png",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Poker|I4M6A5G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Poker.png",
        GPP: "LPOTKGPRP",
        catagory: "Poker"
    },
    {
        NAME: "Teen Patti Test|I0M3A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20Test.png",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Bollywood Casino|I0M7A5G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Bollywood%20Casino.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "32 Cards Casino|I7M6A9G6ES5",
        IMG: "https://d.fawk.app/assets/images/Games/32%20cards%20casino.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Queen|I0M2A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Queen.png",
        GPP: "LROTCGPEP",
        catagory: "Queen"
    },
    {
        NAME: "Worli Matka|I7M3A0G2ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Worli%20Matka.png",
        GPP: "LMOTTGPKP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Amar Akbar Anthony|I1M9A7G8ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Amar%20Akbar%20Anthony.png",
        GPP: "LAOTAGPAP",
        catagory: "Amar"
    },
    {
        NAME: "Poker 20-20|I7M6A5G6ES7",
        IMG: "https://d.fawk.app/assets/images/Games/Poker%2020-20.png",
        GPP: "LPOTKGPRP",
        catagory: "Poker"
    },
    {
        NAME: "29 Cards Baccarat|I0M9A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/29%20Card%20Baccarat.png",
        GPP: "LBOTCGPTP",
        catagory: "Baccarat"
    },
    {
        NAME: "Muflis Teenpatti|I0M0A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Muflis%20Teenpatti.png",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Race To 2017|I0M1A7G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Race%20to%2017.png",
        GPP: "LROTCGPEP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Trio|I0M1A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Trio.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "The Trap|I0M8A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/The%20Trap.png",
        GPP: "LROTCGPEP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Race 20-20|I0M0A1G0ES9",
        IMG: "https://d.fawk.app/assets/images/Games/Race%2020-20.png",
        GPP: "LROTCGPEP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Six Player Poker|I5M6A5G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Six%20player%20poker.png",
        GPP: "LPOTKGPRP",
        catagory: "Poker"
    },
    {
        NAME: "Casino Meter|I5M7A5G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Casino%20Meter.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Casino War|I0M8A5G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Casino%20War.png",
        GPP: "LCOTCGPOP",
        catagory: "Teenpatti"
    },
    {
        NAME: "Teenpatti Open|I0M4A6G7ES6",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20Open.png",
        GPP: "LTOTPGPTP",
        catagory: "Teenpatti"
    },
    /*============================================*/
    {
        NAME: "Baccarat (Virtual)|V9I3R0TU2L9",
        IMG: "https://d.fawk.app/assets/images/Games/29%20Card%20Baccarat.png",
        GPP: "LBOTCGPTP",
        catagory: "Virtual"
    },
    {
        NAME: "Race 20-20 (Virtual)|V1I0R1TU0L9",
        IMG: "https://d.fawk.app/assets/images/Games/Race%2020-20%20(Virtual).png",
        GPP: "LROTCGPEP",
        catagory: "Virtual"
    },
    {
        NAME: "Amar Akbar Anthony (Virtual)|V5I9R7TU8L9",
        IMG: "https://d.fawk.app/assets/images/Games/Amar%20Akbar%20Anthony%20(Virtual).png",
        GPP: "LAOTAGPAP",
        catagory: "Virtual"
    },
    {
        NAME: "Poker 20-20 (Virtual)|V8I6R5TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Poker%2020-20%20(Virtual).png",
        GPP: "LPOTKGPRP",
        catagory: "Virtual"
    },
    {
        NAME: "Teenpatti Open (Virtual)|V1I4R6TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20Open%20(virtual).png",
        GPP: "LTOTPGPTP",
        catagory: "Virtual"
    },
    {
        NAME: "Teenpatti Test (Virtual)|V1I3R6TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20Test%20(virtual).png",
        GPP: "LTOTPGPTP",
        catagory: "Virtual"
    },
    {
        NAME: "Queen (Virtual)|V1I2R6TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Queen%20(virtual).png",
        GPP: "LROTCGPEP",
        catagory: "Virtual"
    },
    {
        NAME: "Trio (Virtual)|V1I1R6TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Trio%20(virtual).png",
        GPP: "LCOTCGPOP",
        catagory: "Virtual"
    },
    {
        NAME: "Muflis Teenpatti (Virtual)|V1I0R6TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Muflis%20Teenpatti%20(virtual).png",
        GPP: "LTOTPGPTP",
        catagory: "Virtual"
    },
    {
        NAME: "Casino War (Virtual)|V1I8R5TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Casino%20War%20(Virtual).png",
        GPP: "LCOTCGPOP",
        catagory: "Virtual"
    },
    {
        NAME: "Casino Meter (Virtual)|V6I7R5TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Casino%20Meter%20(Virtual).png",
        GPP: "LCOTCGPOP",
        catagory: "Virtual"
    },
    {
        NAME: "Bollywood Casino (Virtual)|V1I7R5TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Bollywood%20Casino%20(Virtual).png",
        GPP: "LCOTCGPOP",
        catagory: "Virtual"
    },
    {
        NAME: "7 Up 7 Down (Virtual)|V3I9R7TU8L9",
        IMG: "https://d.fawk.app/assets/images/Games/7%20up%20&%20Down%20(Virtual).png",
        GPP: "LSOTUGPDP",
        catagory: "Virtual"
    },
    {
        NAME: "Teenpatti T-20 (Virtual)|V9I6R7TU6L5",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20T20%20(Virtual).png",
        GPP: "LTOTPGPTP",
        catagory: "Virtual"
    },
    {
        NAME: "Andar Bahar (Virtual)|V5I6R5TU7L8",
        IMG: "https://d.fawk.app/assets/images/Games/Andar%20Bahar%20(Virtual).png",
        GPP: "LAOTBGPRP",
        catagory: "Virtual"
    },
    {
        NAME: "Hi Low (Virtual)|V9I6R9TU6L5",
        IMG: "https://d.fawk.app/assets/images/Games/Hi%20Low%20(Virtual).png",
        GPP: "LHOTLGPWP",
        catagory: "Virtual"
    },
    {
        NAME: "Dragon Tiger (Virtual)|V4I9R7TU8L9",
        IMG: "https://d.fawk.app/assets/images/Games/Dragon%20Tiger%20(Virtual).png",
        GPP: "LDOTTGPRP",
        catagory: "Virtual"
    },
    {
        NAME: "Teenpatti One-Day (Virtual)|V6I6R7TU6L5",
        IMG: "https://d.fawk.app/assets/images/Games/Teenpatti%20One-Day%20(Virtual).png",
        GPP: "LTOTPGPTP",
        catagory: "Virtual"
    },
    {
        NAME: "32 Cards Casino (Virtual)|V6I6R9TU6L5",
        IMG: "https://d.fawk.app/assets/images/Games/32%20cards%20casino%20(Virtual).png",
        GPP: "LCOTCGPOP",
        catagory: "Virtual"
    },
    {
        NAME: "Matka (Virtual)|V6I3R0TU2L9",
        IMG: "https://d.fawk.app/assets/images/Games/Matka%20(Virtual).png",
        GPP: "LMOTTGPKP",
        catagory: "Virtual"
    },
    {
        NAME: "Poker (Virtual)|V3I6R5TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Poker%20%20(Virtual).png",
        GPP: "LPOTKGPRP",
        catagory: "Virtual"
    },
    {
        NAME: "Six Player Poker (Virtual)|V6I6R5TU7L6",
        IMG: "https://d.fawk.app/assets/images/Games/Six%20player%20poker%20(Virtual).png",
        GPP: "LPOTKGPRP",
        catagory: "Virtual"
    },
    {
        NAME: "Roulette (Virtual)|V2I9R7TU8L9",
        IMG: "https://d.fawk.app/assets/images/Games/Roulette%20(Virtual).png",
        GPP: "LROTLGPTP",
        catagory: "Virtual"
    },
]
const _DREAM_CASINO_GAMES =
{
    "Indian": [
        {
            "category": "Live Dealer",
            "game_code": "ezg_betonteenpatti",
            "game_id": 6943,
            "name": "Bet On Teen Patti",
            "product": "Ezugi",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ezg_betonteenpatti.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ezg_andarbahar",
            "game_id": 3929,
            "name": "Andar Bahar",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_andarbahar.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_andarbahar.jpg"
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_indianroulette",
            "game_id": "9754",
            "name": "Indian Roulette",
            "product": "Evolution Gaming",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/evo_indianroulette.jpg"
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_nocommspeedbaccarat",
            "game_id": "2082",
            "name": "No Comm Speed Baccarat",
            "product": "Evolution Gaming",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/evo_nocommspeedbaccarat.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ezg_32cards",
            "game_id": 9748,
            "name": "32 Cards",
            "product": "Ezugi",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ezg_32cards-thumb.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ezg_ottab",
            "game_id": 9750,
            "name": "OTT Andar Bahar",
            "product": "Ezugi",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ott-ab-thumbnail.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ezg_teenpatti",
            "game_id": "3920",
            "name": "Teen Patti",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_teenpatti.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_teenpatti.jpg"
        },
        {
            "category": "Table Games",
            "game_code": "ssc_teen-patti20-20lowroller",
            "game_id": "11564",
            "name": "Teen-Patti 20-20 Low Roller",
            "product": "Super Spade Games",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ssc_teen-patti20-20highroller.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ssc_casinowarlow-roller",
            "game_id": "2648",
            "name": "Casinowar (low-roller)",
            "product": "Super Spade Games",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/superspadeclub/casino-war-2-thumb.jpg"
        },
        {
            "category": "Table Games",
            "game_code": "ssc_ncandar-baharlowroller",
            "game_id": "11556",
            "name": "NC Andar-Bahar Low Roller",
            "product": "Super Spade Games",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ssc_ncandar-baharlowroller.jpg"
        },
        {
            "category": "Live Baccarat",
            "game_code": "ezg_dragontiger",
            "game_id": 3900,
            "name": "Dragon Tiger",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_dragontiger.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_dragontiger.jpg"
        },
        {
            "category": "Live Baccarat",
            "game_code": "ezg_speedcricketbaccarat",
            "game_id": 3898,
            "name": "Speed Cricket Baccarat",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_speedcricketbaccarat.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_speedcricketbaccarat.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ssc_speedandarbaharlow-roller",
            "game_id": "2659",
            "name": "Speed Andar Bahar (low-roller)",
            "product": "Super Spade Games",
            "url_background": "https://cdn.dreamcasino.live/superspadeclub-speedandarbahar-bg.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/superspadeclub/andarbahar-lowroller-thumb.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ssc_dragontigerlow-roller",
            "game_id": "2663",
            "name": "Dragon Tiger (low-roller)",
            "product": "Super Spade Games",
            "url_background": "https://cdn.dreamcasino.live/superspadeclub-dragontiger-bg.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/superspadeclub/dragontiger-lowroller-thumb.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "evo_dragontiger",
            "game_id": "2072",
            "name": "Dragon Tiger",
            "product": "Evolution Gaming",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/evo_dragontiger.jpg"
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_livespeedbaccarata",
            "game_id": "2073",
            "name": "Speed Baccarat A",
            "product": "Evolution Gaming",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/evo_livespeedbaccarata.jpg"
        },
        // {
        //   "category": "Live Baccarat",
        //   "game_code": "ezg_marinacasinobaccarat1",
        //   "game_id": 3902,
        //   "name": "Marina Casino Baccarat 1",
        //   "product": "Ezugi",
        //   "url_background": null,
        //   "url_thumb": "https://cdn.dreamcasino.live/ezugi/ezg_marinacasinobaccarat1.jpg"
        // },
        {
            "category": "Live Roulette",
            "game_code": "ezg_namasteroulette",
            "game_id": 8078,
            "name": "Namaste Roulette",
            "product": "Ezugi",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/namaste-roulette-thumb-v2.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ssc_ncandarbahar",
            "game_id": "3690",
            "name": "NC Andar Bahar",
            "product": "Super Spade Games",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ssc_ncandarbahar.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "ssc_k2andar-baharlowroller",
            "game_id": "11548",
            "name": "Andar-Bahar Low Roller",
            "product": "Super Spade Games",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ssc_k2andar-baharhighroller.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ssc_teenpatti",
            "game_id": "3556",
            "name": "Teen Patti",
            "product": "Super Spade Games",
            "url_background": null,
            "url_thumb": "https://cdn.dreamcasino.live/ssc_teenpatti.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-dragontiger",
            "game_id": "12764",
            "name": "Live - Dragon Tiger",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_dragontiger.jpg",
            "url_thumb": null
        }
    ],
    "Roulette": [
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-rouletteauto",
            "game_id": "11437",
            "name": "Live - Roulette Auto 1",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_live-rouletteauto.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/auto-roulette-bg.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-speedroulette",
            "game_id": "11448",
            "name": "Live - Speed Roulette 1",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_live-speedroulette.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_live-speedroulette.jpg"
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_livespeedroulette",
            "game_id": "2139",
            "name": "Speed Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livespeedroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_liveimmersiveroulette",
            "game_id": "2137",
            "name": "Immersive Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_liveimmersiveroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_liveauto-roulette",
            "game_id": "2138",
            "name": "Auto-Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_liveauto-roulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_liveamericanroulette",
            "game_id": "2142",
            "name": "American Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_liveamericanroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_livedoubleballroulette",
            "game_id": "2143",
            "name": "Double Ball Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livedoubleballroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_speedautoroulette",
            "game_id": "2144",
            "name": "Speed Auto Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_speedautoroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_firstpersonroulette",
            "game_id": "2198",
            "name": "First Person Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_firstpersonroulette.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/RNG-Roulette-bg.jpg"
        },
        {
            "category": "Live Roulette",
            "game_code": "evo_indianroulette",
            "game_id": "9754",
            "name": "Indian Roulette",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_indianroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "ezg_oraclecasinoroulette360",
            "game_id": "3914",
            "name": "Oracle Casino Roulette 360",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_oraclecasinoroulette360.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "ezg_marinacasinoroulette",
            "game_id": "3915",
            "name": "Marina Casino Roulette",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezugi/ezg_marinacasinoroulette.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "ezg_autoroulette",
            "game_id": "3916",
            "name": "Auto Roulette",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/auto-roulette-thumbb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/auto-roulette-bgg.jpg"
        },
        {
            "category": "Live Roulette",
            "game_code": "ezg_speedautoroulette",
            "game_id": "3917",
            "name": "Speed Auto Roulette",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_speedautoroulette.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_speedautoroulette.jpg"
        },
        {
            "category": "Live Roulette",
            "game_code": "ezg_prestigeautoroulette",
            "game_id": "3918",
            "name": "Prestige Auto Roulette",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_prestigeautoroulette.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_prestigeautoroulette.jpg"
        },
        {
            "category": "Live Roulette",
            "game_code": "ezg_namasteroulette",
            "game_id": "8078",
            "name": "Namaste Roulette",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/namaste-roulette-thumb-v2.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Roulette",
            "game_code": "otl_roulette1",
            "game_id": "10729",
            "name": "Roulette 1",
            "product": "Onetouch Live",
            "url_background": "https://cdn.dreamcasino.live/otl_roulette1.jpg",
            "url_thumb": null
        }
    ],
    "Baccarat": [
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-speedbaccaratd",
            "game_id": "13218",
            "name": "Live - Speed Baccarat 5",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_live-speedbaccaratd.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-speedbaccarate",
            "game_id": "13682",
            "name": "Live - Speed Baccarat 6",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_live-speedbaccarate.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-speedbaccarata",
            "game_id": "11451",
            "name": "Live - Speed Baccarat 1",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_live-speedbaccarata.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_nocommspeedbaccarat",
            "game_id": "2082",
            "name": "No Comm Speed Baccarat",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_nocommspeedbaccarat.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_nocommissionbaccarat",
            "game_id": "2083",
            "name": "No Commission Baccarat",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_nocommissionbaccarat.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_livespeedbaccarata",
            "game_id": "2073",
            "name": "Speed Baccarat A",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livespeedbaccarata.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_livespeedbaccaratb",
            "game_id": "2074",
            "name": "Speed Baccarat B",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livespeedbaccaratb.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_livespeedbaccaratc",
            "game_id": "2075",
            "name": "Speed Baccarat C",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livespeedbaccaratc.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_livespeedbaccaratd",
            "game_id": "2076",
            "name": "Speed Baccarat D",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livespeedbaccaratd.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_livespeedbaccarate",
            "game_id": "2077",
            "name": "Speed Baccarat E",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_livespeedbaccarate.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "evo_firstpersondragontiger",
            "game_id": "3947",
            "name": "First Person Dragon Tiger",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_firstpersondragontiger.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "ezg_baccaratsuper6",
            "game_id": "3899",
            "name": "Baccarat Super 6",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_baccaratsuper6.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "ezg_dragontiger",
            "game_id": "3900",
            "name": "Dragon Tiger",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_dragontiger.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_dragontiger.jpg"
        },
        {
            "category": "Live Baccarat",
            "game_code": "ezg_nocommissionbaccarat",
            "game_id": "3901",
            "name": "No Commission Baccarat",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_nocommissionbaccarat.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_nocommissionbaccarat.jpg"
        },
        // {
        //   "category": "Live Baccarat",
        //   "game_code": "ezg_salsabaccarat4",
        //   "game_id": "3905",
        //   "name": "Salsa Baccarat 4",
        //   "product": "Ezugi",
        //   "url_background": "https://cdn.dreamcasino.live/ezg_salsabaccarat4.jpg",
        //   "url_thumb": null
        // },
        {
            "category": "Live Baccarat",
            "game_code": "ezg_baccaratlobby",
            "game_id": "3923",
            "name": "Baccarat Lobby",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_baccaratlobby.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "onto_baccarat1",
            "game_id": "9511",
            "name": "Baccarat 1",
            "product": "Onetouch Live",
            "url_background": "https://cdn.dreamcasino.live/onto_baccarat1-thumb.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Baccarat",
            "game_code": "onto_speedbaccarat",
            "game_id": "9513",
            "name": "Speed Baccarat",
            "product": "Onetouch Live",
            "url_background": "https://cdn.dreamcasino.live/onto_speed_baccarat-thumb.jpg",
            "url_thumb": null
        }
    ],
    "Fungames": [
        {
            "category": "Live Dealer",
            "game_code": "evo_fantan",
            "game_id": "13914",
            "name": "Fan Tan",
            "product": "Evolution Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/evo_fantan.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "evo_gonzostreasurehunt",
            "game_id": "12797",
            "name": "Gonzo's Treasure Hunt",
            "product": "Evolution Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/evo_gonzostreasurehunt_th.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "evo_firstpersoncraps",
            "game_id": "9427",
            "name": "First Person Craps",
            "product": "Evolution Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/craps-first-person-thumbnail.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "evo_craps",
            "game_id": "8508",
            "name": "Craps",
            "product": "Evolution Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/Craps_Thumbnail.jpg"
        },
        {
            "category": "Live Lottery",
            "game_code": "ezg_lotterylobby",
            "game_id": "3927",
            "name": "Lottery Lobby",
            "product": "Ezugi",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_lotterylobby.jpg"
        },
        {
            "category": "Live Sicbo",
            "game_code": "ezg_sicbo",
            "game_id": "9752",
            "name": "Sic Bo",
            "product": "Ezugi",
            "url_thumb": "https://cdn.dreamcasino.live/sicbo-thumbnail.jpg"
        },
        {
            "category": "Multiplayer",
            "game_code": "sbe_aviator",
            "game_id": "8985",
            "name": "AVIATOR",
            "product": "Spribe",
            "url_thumb": "https://cdn.dreamcasino.live/sbe_aviator.png"
        },
        {
            "category": "Casual Games",
            "game_code": "sbe_goal",
            "game_id": "8989",
            "name": "GOAL",
            "product": "Spribe",
            "url_thumb": "https://cdn.dreamcasino.live/sbe_goal.png"
        },
        {
            "category": "Casual Games",
            "game_code": "sbe_mines",
            "game_id": "8987",
            "name": "MINES",
            "product": "Spribe",
            "url_thumb": "https://cdn.dreamcasino.live/sbe_mines.png"
        },
        {
            "category": "Casual Games",
            "game_code": "sbe_hilo",
            "game_id": "8984",
            "name": "HILO",
            "product": "Spribe",
            "url_thumb": "https://cdn.dreamcasino.live/sbe_hilo.png"
        },
        {
            "category": "Casual Games",
            "game_code": "sbe_keno",
            "game_id": "8982",
            "name": "KENO",
            "product": "Spribe",
            "url_thumb": "https://cdn.dreamcasino.live/sbe_keno.png"
        },
        {
            "category": "Video Slots",
            "game_code": "spg_alienhunter",
            "game_id": "12799",
            "name": "Alien Hunter",
            "product": "Spadegaming",
            "url_thumb": "https://cdn.dreamcasino.live/alien-hunter-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "game_code": "spg_zombieparty",
            "game_id": "13511",
            "name": "Zombie Party",
            "product": "Spadegaming",
            "url_thumb": "https://cdn.dreamcasino.live/ZombieParty_Thumbnail.jpg"
        }
    ],
    "Blackjack": [
        {
            "category": "Live Baccarat",
            "game_code": "ezg_speedcricketbaccarat",
            "game_id": "3898",
            "name": "Speed Cricket Baccarat",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_speedcricketbaccarat.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_speedcricketbaccarat.jpg"
        },
        {
            "category": "Live Blackjack",
            "game_code": "ezg_blackjacklobby",
            "game_id": "3924",
            "name": "Blackjack Lobby",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_blackjacklobby.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_blackjacklobby.jpg"
        },
        {
            "category": "Live Blackjack",
            "game_code": "evo_freebetblackjack",
            "game_id": "2093",
            "name": "Free Bet Blackjack",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_freebetblackjack.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Blackjack",
            "game_code": "evo_liveblackjacklobby",
            "game_id": "2162",
            "name": "Blackjack Lobby",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_liveblackjacklobby.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Blackjack",
            "game_code": "evo_firstpersonblackjack",
            "game_id": "2200",
            "name": "First Person Blackjack",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_firstpersonblackjack.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-lobbybj",
            "game_id": "11436",
            "name": "Live - Lobby BJ",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/bj-lobby-thum.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bj-lobby-bg.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-oneblackjack",
            "game_id": "11642",
            "name": "Live - ONE Blackjack",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/one-blackjack-thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/one-blackjack-bg.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-blackjackazureb",
            "game_id": "11245",
            "name": "Live - Blackjack 6 Azure",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/ppl_live-blackjackazureb.jpg",
            "url_thumb": null
        }
    ],
    "Poker": [
        {
            "category": "Live Poker",
            "game_code": "evo_livetriplecardpoker",
            "game_id": "2152",
            "hit_ratio": "Triple Card Poker",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/evo_livetriplecardpoker.jpg",
            "url_background": "https://cdn.dreamcasino.live/liw_firstdrawnnumberwin548.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "evo_livecaribbeanstudpoker",
            "game_id": "2153",
            "hit_ratio": "Caribbean Stud Poker",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/evo_livecaribbeanstudpoker.jpg",
            "url_background": "https://cdn.dreamcasino.live/evo_livecaribbeanstudpoker.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "evo_texasholdembonuspoker",
            "game_id": "2154",
            "hit_ratio": "Texas Hold'em Bonus Poker",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/evo_texasholdembonuspoker.jpg",
            "url_background": "https://cdn.dreamcasino.live/evo_texasholdembonuspoker.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "evo_pokerlobby",
            "game_id": "2338",
            "hit_ratio": "Poker Lobby",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/evo_pokerlobby.jpg",
            "url_background": null,
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "evo_threecardpokerlobby",
            "game_id": "3072",
            "hit_ratio": "Three Card Poker Lobby",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/threecardpoker-thumb.jpg",
            "url_background": null,
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "ezg_pokerlobby",
            "game_id": "3921",
            "hit_ratio": "Poker Lobby",
            "name": "Ezugi",
            "product": "https://cdn.dreamcasino.live/ezg_pokerlobby.jpg",
            "url_background": "https://cdn.dreamcasino.live/ezg_pokerlobby.jpg",
            "url_thumb": null
        },
        {
            "category": "Poker",
            "game_code": "evp_texasholdempoker",
            "game_id": "8042",
            "hit_ratio": "Texas Holdem Poker",
            "name": "Evoplay Entertainment",
            "product": "https://cdn.dreamcasino.live/evp_texasholdempoker.png",
            "url_background": "https://cdn.dreamcasino.live/evp_texasholdempoker.jpg",
            "url_thumb": null
        },
        {
            "category": "Poker",
            "game_code": "evp_indianpoker",
            "game_id": "8214",
            "hit_ratio": "Indian Poker",
            "name": "Evoplay Entertainment",
            "product": "https://cdn.dreamcasino.live/evp_pokerteenpatti.jpg",
            "url_background": "https://cdn.dreamcasino.live/evp_pokerteenpatti.jpg",
            "url_thumb": null
        },
        {
            "category": "Table Games",
            "game_code": "ont_inbetweenpoker",
            "game_id": "634",
            "hit_ratio": "In Between Poker",
            "name": "OneTouch",
            "product": "https://cdn.dreamcasino.live/in-between-poker-thumb.jpg",
            "url_background": "https://cdn.dreamcasino.live/ont_inbetweenpoker.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "evo_threecardpokerlobby",
            "game_id": "3072",
            "hit_ratio": "Three Card Poker Lobby",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/threecardpoker-thumb.jpg",
            "url_background": "https://cdn.dreamcasino.live/threecardpoker-bg.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "evo_ultimatetexasholdemlobby",
            "game_id": "3073",
            "hit_ratio": "Ultimate Texas Holdem Lobby",
            "name": "Evolution Gaming",
            "product": "https://cdn.dreamcasino.live/evo_ultimatetexasholdemlobby.jpg",
            "url_background": "https://cdn.dreamcasino.live/evo_ultimatetexasholdemlobby.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Poker",
            "game_code": "ezg_casinoholdem",
            "game_id": "3919",
            "hit_ratio": "Casino Hold'em",
            "name": "Ezugi",
            "product": "https://cdn.dreamcasino.live/ezg_casinoholdem.jpg",
            "url_background": "https://cdn.dreamcasino.live/ezg_casinoholdem.jpg",
            "url_thumb": null
        }
    ],
    "TVGameshow": [
        {
            "category": "Live Games",
            "game_code": "bgt_lucky7",
            "game_id": "6506",
            "name": "Lucky 7",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_lucky7.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_lucky7.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_diceduel",
            "game_id": "6507",
            "name": "Dice Duel",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_diceduel.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_diceduel.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_poker6",
            "game_id": "6508",
            "name": "Poker 6+",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_poker6.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_poker6.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_warofbets",
            "game_id": "6509",
            "name": "War Of Bets",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_warofbets.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_warofbets.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_wheeloffortune",
            "game_id": "6510",
            "name": "Wheel Of Fortune",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_wheeloffortune.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_wheeloffortune.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_baccarat",
            "game_id": "6511",
            "name": "Baccarat",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_baccarat.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_baccarat.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_speedy7",
            "game_id": "6512",
            "name": "Speedy 7",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_speedy7.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_speedy7.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_lucky6",
            "game_id": "6513",
            "name": "Lucky 6",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_lucky6.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_lucky6.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_bet-on-poker",
            "game_id": "6514",
            "name": "Bet-on-Poker",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_bet-on-poker.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_bet-on-poker.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_lucky5",
            "game_id": "6515",
            "name": "Lucky 5",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/bgt_lucky5.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bgt_lucky5.jpg"
        },
        {
            "category": "Live Games",
            "game_code": "bgt_rockpaperscissors",
            "game_id": "11598",
            "name": "Rock Paper Scissors",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/betgamestv/bgt_rockpaperscissors-thumb.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Dealer",
            "game_code": "bgt_andarbahar",
            "game_id": "12834",
            "name": "Andar Bahar",
            "product": "BetGames.TV",
            "url_background": "https://cdn.dreamcasino.live/btg_andarbahar-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/btg_andarbahar-bg.jpg"
        },
        {
            "category": "Live Lottery",
            "game_code": "liw_luckysix3548",
            "game_id": "9163",
            "name": "Lucky Six 35/48",
            "product": "Lotto Instant Win",
            "url_background": "https://cdn.dreamcasino.live/liw_luckysix3548.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/liw_luckysix3548.jpg"
        },
        {
            "category": "Live Lottery",
            "game_code": "liw_firstdrawnnumberwin548",
            "game_id": "9169",
            "name": "First drawn number (Win 5/48)",
            "product": "Lotto Instant Win",
            "url_background": "https://cdn.dreamcasino.live/liw_firstdrawnnumberwin548.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/liw_firstdrawnnumberwin548.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-megawheel",
            "game_id": "11257",
            "name": "Live - Mega Wheel",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/pgp_mega_wheels_thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_mega_wheels_bg.jpg"
        },
        {
            "category": "Live Dealer",
            "game_code": "ppl_live-gameshows",
            "game_id": "11429",
            "name": "Live - GAMESHOWS",
            "product": "Pragmatic Play Live",
            "url_background": "https://cdn.dreamcasino.live/pragmatic/ppl_live-gameshows-thumb.png",
            "url_thumb": null
        },
        {
            "category": "Live Games",
            "game_code": "evo_dealornodeal",
            "game_id": "2721",
            "name": "Deal or No Deal",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/evo_dealnodeal.jpg",
            "url_thumb": null
        },
        {
            "category": "Live Dealer",
            "game_code": "evo_firstpersonmegaball",
            "game_id": "3936",
            "name": "First Person Mega Ball",
            "product": "Evolution Gaming",
            "url_background": "https://cdn.dreamcasino.live/FirstPersonMegaBall_Thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/FirstPersonMegaBall_bg.jpg"
        },
        {
            "category": "Live Lottery",
            "game_code": "ezg_betonnumbers",
            "game_id": "3926",
            "name": "Bet on Numbers",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_betonnumbers.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_betonnumbers.jpg"
        }
    ],
    "Casino": [
        {
            "category": "Video Poker",
            "game_code": "ont_texasholdem",
            "game_id": 609,
            "name": "Texas Holdem",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/HoldEm_regular.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Baccarat",
            "game_code": "ont_baccarat",
            "game_id": 610,
            "name": "Baccarat",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/Baccara_regular.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Sic Bo",
            "game_code": "ont_sicbo",
            "game_id": 611,
            "name": "Sic Bo",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/SicBo_regular.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Poker",
            "game_code": "ont_russianpoker",
            "game_id": 612,
            "name": "RussianPoker",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/RussianPoker_BitCasino.png",
            "url_thumb": "https://cdn.dreamcasino.live/ont_russianpoker.png",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Blackjack",
            "game_code": "ont_blackjackclassic",
            "game_id": 613,
            "name": "Blackjack Classic",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/BlackJack_regular.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Poker",
            "game_code": "evp_texasholdempoker",
            "game_id": "8042",
            "name": "Texas Holdem Poker",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_texasholdempoker.png",
            "url_thumb": "https://cdn.dreamcasino.live/evp_texasholdempoker.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Blackjack",
            "game_code": "evp_blackjackluckysevens",
            "game_id": "7942",
            "name": "BlackJack Lucky Sevens",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_blackjackluckysevens.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_blackjackluckysevens.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Poker",
            "game_code": "evp_oasispokerclassic",
            "game_id": "7944",
            "name": "Oasis Poker Classic",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_oasispokerclassic.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_oasispokerclassic.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Poker",
            "game_code": "evp_oasispokerproseries",
            "game_id": "7946",
            "name": "Oasis Poker Pro Series",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_oasispokerproseries.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Bingo",
            "game_code": "clt_bananabingo",
            "game_id": "3675",
            "name": "Banana Bingo",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_bananabingo-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bananabingo-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Bingo",
            "game_code": "clt_bingotrevodasorte",
            "game_id": "3676",
            "name": "Bingo Trevo da Sorte",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_bingotrevodasorte-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingotrevodasorte-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Bingo",
            "game_code": "clt_bingoseoritacalavera",
            "game_id": "6731",
            "name": "Bingo Señorita Calavera",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_senoritacalavera-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_senoritacalavera-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Keno",
            "game_code": "clt_bananakeno",
            "game_id": "8690",
            "name": "Banana Keno",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/BananaKeno_Thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/BananaKeno_bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "false"
        },
        {
            "category": "Keno",
            "game_code": "clt_junglekeno",
            "game_id": "8692",
            "name": "Jungle Keno",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/JungleKeno_Thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/JungleKeno_bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "false"
        },
        {
            "category": "Keno",
            "game_code": "clt_magicalkeno",
            "game_id": "8694",
            "name": "Magical Keno",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/MagicalKeno_Thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/MagicalKeno_bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Poker",
            "game_code": "bst_caribbeanpoker",
            "game_id": "852",
            "name": "Caribbean Poker",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_caribbeanpoker.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Table Games",
            "game_code": "bst_drawhi-lo",
            "game_id": "855",
            "name": "Draw Hi-Lo",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_drawhi-lo.png",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        }
    ],
    "Slots": [
        {
            "category": "Video Slots",
            "game_code": "clt_basketballpro",
            "game_id": "626",
            "name": "Basketball Pro",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_basketballpro-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_basketballpro-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "clt_footballpro",
            "game_id": "627",
            "name": "Football Pro",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_footballpro-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_footballpro-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "ezg_onedayteenpatticlassic",
            "game_id": 6487,
            "name": "One Day Teen Patti Classic",
            "product": "Ezugi",
            "url_background": "https://cdn.dreamcasino.live/ezg_onedayteenpatticlassic.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ezg_onedayteenpatticlassic.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_horseracingroulettev2",
            "game_id": "7193",
            "name": "Horse Racing Roulette V2",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/53a22a9abcc00d7554bcac646e4af6f2.png",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_kenosmartplaykeno",
            "game_id": "7179",
            "name": "Keno (Smart Play Keno)",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/e78af8d875d1d11227c380ab674b8424.png",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_rollthedice",
            "game_id": "7936",
            "name": "Roll The Dice",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_rollthedice.png",
            "url_thumb": "https://cdn.dreamcasino.live/evp_rollthedice.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_headstails",
            "game_id": "7938",
            "name": "Heads & Tails",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_headstails.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_headstails.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_moreorless",
            "game_id": "7940",
            "name": "More or Less",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_moreorless.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_moreorless.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_fouraces",
            "game_id": "7952",
            "name": "Four Aces",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_fouraces.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fouraces.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_redqueen",
            "game_id": "7954",
            "name": "Red Queen",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_redqueen.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_redqueen.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_thimbles",
            "game_id": "7956",
            "name": "Thimbles",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_thimbles.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_thimbles.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Roulette",
            "game_code": "evp_europeanroulette",
            "game_id": "7962",
            "name": "European Roulette",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_europeanroulette.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_europeanroulette.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "evp_luckygirls",
            "game_id": "7982",
            "name": "Lucky Girls",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_luckygirls.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_luckygirls.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Casual Games",
            "game_code": "evp_rockpaperscissors",
            "game_id": "7984",
            "name": "Rock Paper Scissors",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/evp_rockpaperscissors.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/evp_rockpaperscissors.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Instant Win Games",
            "game_code": "evp_bonanzawheel",
            "game_id": "13702",
            "name": "Bonanza Wheel",
            "product": "Evoplay Entertainment",
            "url_background": "https://cdn.dreamcasino.live/bonanza-wheel-thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/bonanza-wheel-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Wheel of Fortune",
            "game_code": "ont_wheeloffortune",
            "game_id": "636",
            "name": "Wheel Of Fortune",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/WOF_thumbnail_490x368.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ont_wheeloffortune.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "false"
        },
        {
            "category": "Video Slots",
            "game_code": "ont_sumoshowdown-4reels",
            "game_id": "637",
            "name": "Sumo Showdown - 4 reels",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/SumoShowdown-thumb.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "ont_juicy7-3reels",
            "game_id": "638",
            "name": "Juicy7 - 3 reels",
            "product": "OneTouch",
            "url_background": "https://cdn.dreamcasino.live/Juicy7_thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ont_juicy7-3reels.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "clt_dragonrising",
            "game_id": "644",
            "name": "Dragon Rising",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_dragonrising-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_dragonrising-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "clt_piratesoffortune",
            "game_id": "645",
            "name": "Pirates of Fortune",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_piratesoffortune-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_piratesoffortune-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "clt_goldfever",
            "game_id": "646",
            "name": "Gold Fever",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/clt_goldfever-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/clt_goldfever-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Scratch Cards",
            "game_code": "clt_raspadinhahalloween",
            "game_id": "12922",
            "name": "Raspadinha Halloween",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/thalloween-raspadinha-humbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/halloween-raspadinha-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Scratch Cards",
            "game_code": "clt_raspadinhatrevodasorte",
            "game_id": "12924",
            "name": "Raspadinha Trevo da Sorte",
            "product": "Caleta Gaming",
            "url_background": "https://cdn.dreamcasino.live/raspadinha-trevo-da-sorte-thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/raspadinha-trevo-da-sorte-bg.jpg",
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "bst_luckyseven",
            "game_id": "754",
            "name": "Lucky Seven",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_luckyseven.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "bst_magicshoppe",
            "game_id": "755",
            "name": "Magic Shoppe",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_magicshoppe.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": "true"
        },
        {
            "category": "Video Slots",
            "game_code": "bst_sushibar",
            "game_id": "804",
            "name": "Sushi Bar",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_sushibar.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "bst_great88",
            "game_id": "805",
            "name": "Great 88",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_great88.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        },
        {
            "category": "Video Slots",
            "game_code": "bst_pinocchio",
            "game_id": "806",
            "name": "Pinocchio",
            "product": "Betsoft",
            "url_background": "https://cdn.dreamcasino.live/bst_pinocchio.jpg",
            "url_thumb": null,
            "Column8": null,
            "Column9": null,
            "Column10": null,
            "Column11": null,
            "Column12": null,
            "Column13": null,
            "Column14": null,
            "Column15": null,
            "Column16": null,
            "Column17": null
        }
    ],
    "Virtualsports": [
        {
            "category": "Video Slots",
            "game_code": "krn_horsesdashingderby",
            "game_id": "7171",
            "name": "Horses (Dashing Derby)",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/73df390a399595fb64c7dc35cfe53a0e.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_dogsplatinumhounds",
            "game_id": "7173",
            "name": "Dogs (Platinum Hounds)",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/81b5b16c4db9c5ddbb6542a5ce8fe99a.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_motorracingmaxcar",
            "game_id": "7175",
            "name": "Motor racing (Max Car)",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/75cdc72f86644ae2a37342afa9ad37eb.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_tabletennis",
            "game_id": "7177",
            "name": "Table tennis",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/b9a34c39f2dbb076000890f1fbebef97.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_footballenglishfastleaguefootballsinglematch",
            "game_id": "7181",
            "name": "Football (English Fast League Football Single Match)",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/5a7522b1dfc4de3d12269d137e98f694.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_golf",
            "game_id": "7187",
            "name": "Golf",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/0981bd47c8369c5af481e50e76b1c6f5.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_spanishfastleaguefootballsingle",
            "game_id": "7189",
            "name": "Spanish FastLeague Football Single",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/c4964021c1036470c9ec07e606d8aa7f.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "krn_italianfastleaguefootballsingle",
            "game_id": "7191",
            "name": "Italian FastLeague Football Single",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/images/ef2d83bfeb1d70678b2ed2770a636e4f.png",
            "url_thumb": null
        },
        {
            "category": "Virtual Sports",
            "game_code": "krn_italianfastleaguefootballmatch",
            "game_id": "10641",
            "name": "Italian FastLeague Football Match",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/italian-fast-league-football-thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/italian-fast-league-football-bg.jpg"
        },
        {
            "category": "Virtual Sports",
            "game_code": "krn_spanishfastleaguefootballmatch",
            "game_id": "10643",
            "name": "Spanish FastLeague Football Match",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/spanish-fast-league-football-thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/spanish-fast-league-football-bg.jpg"
        },
        {
            "category": "Video Slots",
            "game_code": "krn_icehockeyleaguematch",
            "game_id": "12623",
            "name": "Ice Hockey League Match",
            "product": "Kiron",
            "url_background": "https://cdn.dreamcasino.live/ice-hockey-league-match-thumbnail.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/ice-hockey-league-match-bg.jpg"
        },
        {
            "category": "Video Slots",
            "game_code": "edg_virtualcockfighter",
            "game_id": "12331",
            "name": "Virtual cock fighter",
            "product": "Edge Gaming",
            "url_background": "https://cdn.dreamcasino.live/virtualcockfighter-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/virtualcockfighter-bg.jpg"
        },
        {
            "category": "Video Slots",
            "game_code": "edg_virtualicehockey",
            "game_id": "12332",
            "name": "virtual ice hockey",
            "product": "Edge Gaming",
            "url_background": "https://cdn.dreamcasino.live/images/35ba3572482a9692df5901dad1dde1a2.png",
            "url_thumb": null
        },
        {
            "category": "Video Slots",
            "game_code": "edg_virtualcricket",
            "game_id": "12333",
            "name": "virtual cricket",
            "product": "Edge Gaming",
            "url_background": "https://cdn.dreamcasino.live/images/026a2f7d42a9484636759cdccf6afe26.png",
            "url_thumb": null
        },
        {
            "category": "Virtual Sports",
            "game_code": "gdr_goldenrace",
            "game_id": "6984",
            "name": "Golden Race",
            "product": "Golden Race",
            "url_background": "https://cdn.dreamcasino.live/goldenrace/golden-race-thumb.jpg",
            "url_thumb": "https://cdn.dreamcasino.live/goldenrace/golden-race-bg.jpg"
        }
    ],
    "FishshootingGames": [
        {
            "category": "Video Slots",
            "game_code": "spg_fishinggod",
            "game_id": "2394",
            "name": "Fishing God",
            "product": "Spadegaming",
            "url_thumb": "https://cdn.dreamcasino.live/spg_fishinggod.jpg"
        },
        {
            "category": "Baccarat",
            "game_code": "spg_fishingwar",
            "game_id": "2691",
            "name": "Fishing War",
            "product": "Spadegaming",
            "url_thumb": "https://cdn.dreamcasino.live/spg_fishingwar.jpg"
        }
    ],
    "SlotsTomhorn": [
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_243crystalfruits",
            "game_id": "1130",
            "name": "243 Crystal Fruits",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_243crystalfruits.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_blackmummy",
            "game_id": "1135",
            "name": "Black Mummy",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_blackmummy.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_blackbeardsquest",
            "game_id": "1137",
            "name": "Blackbeard's Quest",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_blackbeardsquest.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_bookofspells",
            "game_id": "1141",
            "name": "Book Of Spells",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_bookofspells.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_donjuanspeppers",
            "game_id": "1146",
            "name": "Don Juan's Peppers",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_donjuanspeppers.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_dragonegg",
            "game_id": "1148",
            "name": "Dragon Egg",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_dragonegg.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_dragonriches",
            "game_id": "1149",
            "name": "Dragon Riches",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_dragonriches.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_fengfu",
            "game_id": "1151",
            "name": "Feng Fu",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_fengfu.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_fireandhot",
            "game_id": "1152",
            "name": "Fire 'n' Hot",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_fireandhot.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_flamingfruit",
            "game_id": "1153",
            "name": "Flaming Fruit",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_flamingfruit.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_frozenqueen",
            "game_id": "1155",
            "name": "Frozen Queen",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_frozenqueen.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_geishasfan",
            "game_id": "1156",
            "name": "Geisha's Fan",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_geishasfan.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_hotblizzard",
            "game_id": "1158",
            "name": "Hot Blizzard",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_hotblizzard.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_incastreasure",
            "game_id": "1161",
            "name": "Incas's Treasure",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_incastreasure.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_kongobongo",
            "game_id": "1163",
            "name": "Kongo Bongo",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_kongobongo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_monkey27",
            "game_id": "1166",
            "name": "Monkey 27",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_monkey27.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_monstermadness",
            "game_id": "1168",
            "name": "Monster Madness",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_monstermadness.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_pandasrun",
            "game_id": "1169",
            "name": "Panda's Run",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_pandasrun.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_redlights",
            "game_id": "1172",
            "name": "Red Lights",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_redlights.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_savannahking",
            "game_id": "1175",
            "name": "Savannah King",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_savannahking.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_shaolinstiger",
            "game_id": "1176",
            "name": "Shaolin's Tiger",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_shaolinstiger.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_sherlockascandalinbohemia",
            "game_id": "1179",
            "name": "Sherlock",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_sherlockascandalinbohemia.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_sizablewin",
            "game_id": "1182",
            "name": "Sizable Win",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_sizablewin.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_skybarons",
            "game_id": "1183",
            "name": "Sky Barons",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_skybarons.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_thecup",
            "game_id": "1186",
            "name": "The Cup",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_thecup.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_thronesofpersia",
            "game_id": "1189",
            "name": "Thrones Of Persia",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_thronesofpersia.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_wildweather",
            "game_id": "1193",
            "name": "Wild Weather",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_wildweather.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_diamondhill",
            "game_id": "1854",
            "name": "Diamond Hill",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_diamondhill.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_hotnfruity",
            "game_id": "1855",
            "name": "Hot'n'Fruity",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_hotnfruity.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_spinball",
            "game_id": "1856",
            "name": "Spinball",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/spinball-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_jokereelz",
            "game_id": "6387",
            "name": "Joker Reelz",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_jokereelz.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_thesecretofba",
            "game_id": "7316",
            "name": "The Secret of BA",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/tmh_thesecretofba.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_243crystalfruitsreversed",
            "game_id": "8448",
            "name": "243 Crystal Fruits Reversed",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/243_Crystal_fruits_reversed_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_wolfsierra",
            "game_id": "9412",
            "name": "Wolf Sierra",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/wolf-sierra-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_goldx",
            "game_id": "10276",
            "name": "Gold X",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/GoldX_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_sweetcrush",
            "game_id": "10582",
            "name": "Sweet Crush",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/sweet-crush-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_wheelofluckholdandwin",
            "game_id": "11059",
            "name": "Wheel of Luck Hold and Win",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/WheelOfLuckHoldAndWin_Thumbnail.jpg"
        },
        {
            "category": "Roulette",
            "enabled": "true",
            "game_code": "tmh_europeanrouletteannouncedbets",
            "game_id": "11802",
            "name": "European Roulette Announced Bets",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/european-roulette-announced-bets-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_81frutasgrande",
            "game_id": "12568",
            "name": "81 Frutas Grandes",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/fruiyasgrande-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_latomatina",
            "game_id": "12876",
            "name": "La Tomatina",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/latomatina-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_beastybux",
            "game_id": "13547",
            "name": "Beasty Bux",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/BeastyBux_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "tmh_fruitsgopop",
            "game_id": "13818",
            "name": "Fruits Go Pop",
            "product": "Tom Horn",
            "url_thumb": "https://cdn.dreamcasino.live/FruitsGoPop_Thumbnail.jpg"
        }
    ],
    "SlotsCaleta": [
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_torchoffire",
            "game_id": "619",
            "name": "Torch Of Fire",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_torchoffire-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_hiddenkingdom",
            "game_id": "620",
            "name": "Hidden Kingdom",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_hiddenkingdom-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_magicforest",
            "game_id": "621",
            "name": "Magic Forest",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_magicforest-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_heroesempire",
            "game_id": "622",
            "name": "Heroes Empire",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_heroesempire-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_chinacharms",
            "game_id": "623",
            "name": "China Charms",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_chinacharms-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_luckyexpress",
            "game_id": "624",
            "name": "Lucky Express",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_luckyexpress-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_lostsaga",
            "game_id": "625",
            "name": "Lost Saga",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_lostsaga-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_basketballpro",
            "game_id": "626",
            "name": "Basketball Pro",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_basketballpro-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_footballpro",
            "game_id": "627",
            "name": "Football Pro",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_footballpro-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_enchantedcash",
            "game_id": "639",
            "name": "Enchanted Cash",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_enchantedcash-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_hungrychef",
            "game_id": "640",
            "name": "Hungry Chef",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_hungrychef-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_frightnight",
            "game_id": "641",
            "name": "Fright Night",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_frightnight-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_crazylab",
            "game_id": "643",
            "name": "Crazy Lab",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_crazylab-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_dragonrising",
            "game_id": "644",
            "name": "Dragon Rising",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_dragonrising-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_piratesoffortune",
            "game_id": "645",
            "name": "Pirates of Fortune",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_piratesoffortune-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_goldfever",
            "game_id": "646",
            "name": "Gold Fever",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_goldfever-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_frozenfluffies",
            "game_id": "647",
            "name": "Frozen Fluffies",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_frozenfluffies-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_cuteycats",
            "game_id": "1891",
            "name": "Cutey Cats",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_cuteycats-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_wildfruit",
            "game_id": "2070",
            "name": "Wild Fruit",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_wildfruit-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_cavestreasures",
            "game_id": "2786",
            "name": "Caves & Treasures",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_cavestreasures-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_hallowinner",
            "game_id": "2787",
            "name": "Hallowinner",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_hallowinner-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_cruiseoffortune",
            "game_id": "2794",
            "name": "Cruise of Fortune",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_cruiseoffortune-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_hurricash",
            "game_id": "2795",
            "name": "Hurricash",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_hurricash-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_madamefortune",
            "game_id": "2798",
            "name": "Madame Fortune",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_madamefortune-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_vegasbaby",
            "game_id": "2799",
            "name": "Vegas Baby",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_vegasbabythumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_villagebrewery",
            "game_id": "2800",
            "name": "Village Brewery",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_villagebrewery-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bananabingo",
            "game_id": "3675",
            "name": "Banana Bingo",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bananabingo-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingotrevodasorte",
            "game_id": "3676",
            "name": "Bingo Trevo da Sorte",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingotrevodasorte-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingobruxaria",
            "game_id": "3677",
            "name": "Bingo Bruxaria",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingobruxaria-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingohortinha",
            "game_id": "3678",
            "name": "Bingo Hortinha",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingohortinha-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingognio",
            "game_id": "3881",
            "name": "Bingo Gênio",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingogenio-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingolcia",
            "game_id": "3882",
            "name": "Bingolicia",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingolicia-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_circusbingo",
            "game_id": "3883",
            "name": "Circus Bingo",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_circusbingo-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingopirata",
            "game_id": "3961",
            "name": "Bingo Pirata",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingopirata-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingoiglu",
            "game_id": "3962",
            "name": "Bingo Iglu",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingoiglu-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingocientistadoido",
            "game_id": "3963",
            "name": "Bingo Cientista Doidão",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingocientistadoidao-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingosambario",
            "game_id": "4249",
            "name": "Bingo Samba Rio",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_sambario-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingosenortaco",
            "game_id": "6643",
            "name": "Bingo Señor Taco",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_senortaco-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingosagaloca",
            "game_id": "6645",
            "name": "Bingo Saga Loca",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_sagaloca-thumb.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingoseoritacalavera",
            "game_id": "6731",
            "name": "Bingo Señorita Calavera",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_senoritacalavera-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_bingolaco",
            "game_id": "6941",
            "name": "Bingolaço",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingolaco-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_rctsamba",
            "game_id": "6997",
            "name": "RCT - Samba",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_samba-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_rcthalloween",
            "game_id": "6999",
            "name": "RCT - Halloween",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_rcthalloween-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_feelthemusic",
            "game_id": "7205",
            "name": "Feel The Music",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_feelthemusic-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_dressingroom",
            "game_id": "7207",
            "name": "Dressing Room",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_dressingroom-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_luckyk",
            "game_id": "8072",
            "name": "Lucky K",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_luckyk-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_rct-newfruit",
            "game_id": "8629",
            "name": "RCT - New Fruit",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_newfruit-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_rct-riodejaneiro",
            "game_id": "8631",
            "name": "RCT - Rio de Janeiro",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_riodejaneiro-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_rct-reisdoegito",
            "game_id": "8633",
            "name": "RCT - Reis do Egito",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_reisdoegito-thumb.jpg"
        },
        {
            "category": "Keno",
            "enabled": "true",
            "game_code": "clt_bananakeno",
            "game_id": "8690",
            "name": "Banana Keno",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/BananaKeno_Thumbnail.jpg"
        },
        {
            "category": "Keno",
            "enabled": "true",
            "game_code": "clt_junglekeno",
            "game_id": "8692",
            "name": "Jungle Keno",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/JungleKeno_Thumbnail.jpg"
        },
        {
            "category": "Keno",
            "enabled": "true",
            "game_code": "clt_magicalkeno",
            "game_id": "8694",
            "name": "Magical Keno",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/MagicalKeno_Thumbnail.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_betinabingo",
            "game_id": "8943",
            "name": "Betina Bingo",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/BetinaBingo_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_crystalunicorn",
            "game_id": "8945",
            "name": "Crystal Unicorn",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/CrystalUnicorn_bg.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_oceanrichies",
            "game_id": "8980",
            "name": "Ocean Richies",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/assets/game/lobby/icon.jpg"
        },
        {
            "category": "Lottery",
            "enabled": "true",
            "game_code": "clt_atomicolotto",
            "game_id": "9235",
            "name": "Atomico Lotto",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/atomico-lotto-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_vikingmadness",
            "game_id": "9558",
            "name": "Viking Madness",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_viking_Madness_thumb.jpg"
        },
        {
            "category": "Video Bingo",
            "enabled": "true",
            "game_code": "clt_bingofadadafortuna",
            "game_id": "9714",
            "name": "Bingo Fada da Fortuna",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/fada-da-fortuna-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_princessoftheocean",
            "game_id": "9967",
            "name": "Princess of the Ocean",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_princessoftheocean-thumb.jpg"
        },
        {
            "category": "Video Bingo",
            "enabled": "true",
            "game_code": "clt_bingotornado",
            "game_id": "9969",
            "name": "Bingo Tornado",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/bingo-tornado-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_beachtennis",
            "game_id": "9971",
            "name": "Beach Tennis",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/beach-tennis-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_hungrychefpickem",
            "game_id": "10047",
            "name": "Hungry Chef Pick'em",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/HungryChefPickEm_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_pickemfruits",
            "game_id": "11084",
            "name": "Pick'em Fruits",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_pickemfruits.jpeg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_catchafishbingo",
            "game_id": "11088",
            "name": "Catch a Fish Bingo",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/CatchAFish_Thumbnail.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_botobingo",
            "game_id": "11090",
            "name": "Boto Bingo",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/boto-bingo-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_astrowild",
            "game_id": "11576",
            "name": "Astro Wild",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/AstroWild_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_cherrycherry",
            "game_id": "12728",
            "name": "Cherry Cherry",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/cherrycherry-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_rct-talismanes",
            "game_id": "12880",
            "name": "RCT - Talismanes",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/talismanes-thumbnail.jpg"
        },
        {
            "category": "Scratch Cards",
            "enabled": "true",
            "game_code": "clt_raspadinhahalloween",
            "game_id": "12922",
            "name": "Raspadinha Halloween",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/thalloween-raspadinha-humbnail.jpg"
        },
        {
            "category": "Scratch Cards",
            "enabled": "true",
            "game_code": "clt_raspadinhatrevodasorte",
            "game_id": "12924",
            "name": "Raspadinha Trevo da Sorte",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/raspadinha-trevo-da-sorte-thumbnail.jpg"
        },
        {
            "category": "Bingo",
            "enabled": "true",
            "game_code": "clt_bingohalloween",
            "game_id": "12928",
            "name": "Bingo Halloween",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_bingohalloween.jpg"
        },
        {
            "category": "Keno",
            "enabled": "true",
            "game_code": "clt_kenohalloween",
            "game_id": "13934",
            "name": "Keno Halloween",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/HalloweenKeno_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "clt_halloweenpickem",
            "game_id": "14267",
            "name": "Halloween Pick'em",
            "product": "Caleta Gaming",
            "url_thumb": "https://cdn.dreamcasino.live/clt_halloweenpickem-thumb.jpg"
        }
    ],
    "SlotsBetsoft": [
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_luckyseven",
            "game_id": "754",
            "name": "Lucky Seven",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_luckyseven.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_magicshoppe",
            "game_id": "755",
            "name": "Magic Shoppe",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_magicshoppe.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_thetipsytourist",
            "game_id": "756",
            "name": "The Tipsy Tourist",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_thetipsytourist.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_slotfatherjp",
            "game_id": "757",
            "name": "Slotfather JP",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_slotfatherjp.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_drjekyllmrhyde",
            "game_id": "759",
            "name": "Dr. Jekyll & Mr. Hyde",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_drjekyllmrhyde.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_reelsofwealth",
            "game_id": "760",
            "name": "Reels Of Wealth",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_reelsofwealth.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_barbarycoast",
            "game_id": "761",
            "name": "Barbary Coast",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/Barbary_Coast_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_slotfather2",
            "game_id": "762",
            "name": "Slotfather 2",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_slotfather2.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_dragonkings",
            "game_id": "763",
            "name": "Dragon Kings",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_dragonkings.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_theangler",
            "game_id": "764",
            "name": "The Angler",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_theangler.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_weekendinvegas",
            "game_id": "765",
            "name": "Weekend In Vegas",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_weekendinvegas.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_glamlife",
            "game_id": "766",
            "name": "Glam Life",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_glamlife.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_bloodeternal",
            "game_id": "768",
            "name": "Blood Eternal",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_bloodeternal.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_tigersclaw",
            "game_id": "769",
            "name": "Tiger's Claw",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_tigersclaw.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_houseoffun",
            "game_id": "770",
            "name": "House of Fun",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_houseoffun.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_birds",
            "game_id": "771",
            "name": "Birds",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_birds.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_anightinparisjp",
            "game_id": "772",
            "name": "A Night in Paris JP",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_anightinparisjp.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_thecuriousmachineplus",
            "game_id": "773",
            "name": "The Curious Machine Plus",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_thecuriousmachineplus.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_enchantedjp",
            "game_id": "774",
            "name": "Enchanted JP",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_enchantedjp.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_vikingvoyage",
            "game_id": "775",
            "name": "Viking Voyage",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_vikingvoyage.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_underthesea",
            "game_id": "776",
            "name": "Under the Sea",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_underthesea.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_golddiggers",
            "game_id": "777",
            "name": "Gold Diggers",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_golddiggers.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_4seasons",
            "game_id": "779",
            "name": "4 Seasons",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_4seasons.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_onceuponatime",
            "game_id": "780",
            "name": "Once Upon A Time",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_onceuponatime.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_puppyloveplus",
            "game_id": "781",
            "name": "Puppy Love Plus",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_puppyloveplus.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_thegoldenowlofathena",
            "game_id": "782",
            "name": "The Golden Owl of Athena",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_thegoldenowlofathena.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_underthebed",
            "game_id": "783",
            "name": "Under the Bed",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_underthebed.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_achristmascarol",
            "game_id": "784",
            "name": "A Christmas Carol",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_achristmascarol.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_goldcanyon",
            "game_id": "785",
            "name": "Gold Canyon",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_goldcanyon.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_gladiator",
            "game_id": "786",
            "name": "Gladiator",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_gladiator.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_charmsandclovers",
            "game_id": "787",
            "name": "Charms And Clovers",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_charmsandclovers.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_rooksrevenge",
            "game_id": "788",
            "name": "Rook's Revenge",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_rooksrevenge.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_geniesfortune",
            "game_id": "789",
            "name": "Genie's Fortune",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_geniesfortune.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_megaglamlifejp",
            "game_id": "791",
            "name": "Mega Glam Life JP",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_megaglamlifejp.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_goodgirlbadgirl",
            "game_id": "793",
            "name": "Good Girl, Bad Girl",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_goodgirlbadgirl.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_7thheaven",
            "game_id": "794",
            "name": "7th Heaven",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_7thheaven.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_rockstar",
            "game_id": "795",
            "name": "RockStar",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_rockstar.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_yakyetiroll",
            "game_id": "797",
            "name": "Yak, Yeti & Roll",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_yakyetiroll.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_theexterminator",
            "game_id": "798",
            "name": "The Exterminator",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_theexterminator.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_boomanji",
            "game_id": "799",
            "name": "Boomanji",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_boomanji.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_sugarpop",
            "game_id": "800",
            "name": "Sugar Pop",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_sugarpop.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_ogreempire",
            "game_id": "801",
            "name": "Ogre Empire",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_ogreempire.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_carnavalforever",
            "game_id": "803",
            "name": "Carnaval Forever",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_carnavalforever.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_sushibar",
            "game_id": "804",
            "name": "Sushi Bar",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_sushibar.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_great88",
            "game_id": "805",
            "name": "Great 88",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_great88.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_pinocchio",
            "game_id": "806",
            "name": "Pinocchio",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_pinocchio.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_greedygoblins",
            "game_id": "807",
            "name": "Greedy Goblins",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_greedygoblins.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_2millionbc",
            "game_id": "808",
            "name": "2 Million B.C.",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_2millionbc.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_moregolddiggin",
            "game_id": "809",
            "name": "More Gold Diggin",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_moregolddiggin.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_arrival",
            "game_id": "810",
            "name": "Arrival",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_arrival.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_faeriespells",
            "game_id": "811",
            "name": "Faerie Spells",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_faeriespells.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_afternightfalls",
            "game_id": "812",
            "name": "After Night Falls",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_afternightfalls.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_madderscientist",
            "game_id": "813",
            "name": "Madder Scientist",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_madderscientist.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_atthemovies",
            "game_id": "814",
            "name": "At the Movies",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_atthemovies.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_heist",
            "game_id": "815",
            "name": "Heist",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_heist.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_pacoandthepoppingpeppers",
            "game_id": "816",
            "name": "Paco and the Popping Peppers",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_pacoandthepoppingpeppers.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_atthecopa",
            "game_id": "817",
            "name": "At The Copa",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_atthecopa.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_fa-fatwins",
            "game_id": "818",
            "name": "Fa-Fa Twins",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_fa-fatwins.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_legendofthenile",
            "game_id": "819",
            "name": "Legend Of The Nile",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_legendofthenile.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_sincitynights",
            "game_id": "820",
            "name": "Sin City Nights",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_sincitynights.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_firesteel",
            "game_id": "821",
            "name": "Fire & Steel",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_firesteel.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_treasureroom",
            "game_id": "822",
            "name": "Treasure Room",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_treasureroom.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_sugarpop2",
            "game_id": "823",
            "name": "Sugar Pop 2",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_sugarpop2.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_eventhorizon",
            "game_id": "824",
            "name": "Event Horizon",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_eventhorizon.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_safarisam",
            "game_id": "825",
            "name": "Safari Sam",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_safarisam.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_jumbojoker",
            "game_id": "826",
            "name": "Jumbo Joker",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_jumbojoker.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_slotsangels",
            "game_id": "828",
            "name": "Slots Angels",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_slotsangels.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_frankenslotsmonster",
            "game_id": "829",
            "name": "Frankenslot's Monster",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_frankenslotsmonster.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_chillipop",
            "game_id": "830",
            "name": "Chilli Pop",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_chillipop.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_gypsyrose",
            "game_id": "831",
            "name": "Gypsy Rose",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_gypsyrose.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_megagems",
            "game_id": "832",
            "name": "Mega Gems",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_megagems.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_thetruesheriff",
            "game_id": "833",
            "name": "The True Sheriff",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_thetruesheriff.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_vikingage",
            "game_id": "834",
            "name": "Viking Age",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_vikingage.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_tycoonsplus",
            "game_id": "835",
            "name": "Tycoons Plus",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_tycoonsplus.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_lost",
            "game_id": "836",
            "name": "Lost",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_lost.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_giovannisgems",
            "game_id": "837",
            "name": "Giovanni's Gems",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_giovannisgems.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_trueillusions",
            "game_id": "838",
            "name": "True Illusions",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_trueillusions.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_kawaiikitty",
            "game_id": "839",
            "name": "Kawaii Kitty",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_kawaiikitty.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_alkemorstower",
            "game_id": "841",
            "name": "Alkemor's Tower",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_alkemorstower.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_mammamia",
            "game_id": "842",
            "name": "Mamma Mia",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_mammamia.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_itcamefromvenusjpplus",
            "game_id": "843",
            "name": "It Came From Venus JP Plus",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_itcamefromvenusjpplus.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_fruitzen",
            "game_id": "844",
            "name": "Fruit Zen",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_fruitzen.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_mrvegas",
            "game_id": "845",
            "name": "Mr. Vegas",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_mrvegas.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_stampede",
            "game_id": "846",
            "name": "Stampede",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_stampede.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_21burnblackjack",
            "game_id": "848",
            "name": "21 Burn Blackjack",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_21burnblackjack.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_americanblackjack",
            "game_id": "849",
            "name": "American Blackjack",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_americanblackjack.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_americanroulette",
            "game_id": "850",
            "name": "American Roulette",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_americanroulette.jpg"
        },
        {
            "category": "Baccarat",
            "enabled": "true",
            "game_code": "bst_baccarat",
            "game_id": "851",
            "name": "Baccarat",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_baccarat.jpg"
        },
        {
            "category": "Video Poker",
            "enabled": "true",
            "game_code": "bst_caribbeanpoker",
            "game_id": "852",
            "name": "Caribbean Poker",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_caribbeanpoker.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_drawhi-lo",
            "game_id": "855",
            "name": "Draw Hi-Lo",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_drawhi-lo.png"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_europeanblackjack",
            "game_id": "856",
            "name": "European Blackjack",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_europeanblackjack.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_europeanroulette",
            "game_id": "857",
            "name": "European Roulette",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_europeanroulette.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_oasispoker",
            "game_id": "858",
            "name": "Oasis Poker",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/Oasis_Poker_thumb.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_paigow",
            "game_id": "859",
            "name": "Pai Gow",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_paigow.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_pirate21",
            "game_id": "860",
            "name": "Pirate 21",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_pirate21.jpg"
        },
        {
            "category": "Blackjack",
            "enabled": "true",
            "game_code": "bst_pontoon",
            "game_id": "862",
            "name": "Pontoon",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_pontoon.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_reddog",
            "game_id": "863",
            "name": "Red Dog",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_reddog.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_singledeckblackjack",
            "game_id": "865",
            "name": "Single Deck Blackjack",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_singledeckblackjack.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_super7blackjack",
            "game_id": "866",
            "name": "Super 7 Blackjack",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_super7blackjack.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_threecardrummy",
            "game_id": "867",
            "name": "Three Card Rummy",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_threecardrummy.png"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_topcardtrumps",
            "game_id": "868",
            "name": "Top Card Trumps",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_topcardtrumps.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_tripleedgepoker",
            "game_id": "869",
            "name": "Triple Edge Poker",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_tripleedgepoker.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_vipamericanroulette",
            "game_id": "870",
            "name": "Vip American Roulette",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_vipamericanroulette.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_vipeuropeanroulette",
            "game_id": "871",
            "name": "Vip European Roulette",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_vipeuropeanroulette.jpg"
        },
        {
            "category": "Table Games",
            "enabled": "true",
            "game_code": "bst_zoomroulette",
            "game_id": "872",
            "name": "Zoom Roulette",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_zoomroulette.jpg"
        },
        {
            "category": "Video Poker",
            "enabled": "true",
            "game_code": "bst_deuceswild",
            "game_id": "889",
            "name": "Deuces Wild",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_deuceswild.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_wolfmoonrising",
            "game_id": "1677",
            "name": "Wolf Moon Rising",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_wolfmoonrising.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_bamboorush",
            "game_id": "1784",
            "name": "Bamboo Rush",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_bamboorush.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_gemmed",
            "game_id": "1848",
            "name": "Gemmed",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_gemmed.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_caishensarrival",
            "game_id": "1884",
            "name": "Caishen's Arrival",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_caishensarrival.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_spinfinityman",
            "game_id": "1895",
            "name": "Spinfinity Man",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_spinfinityman.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_fruitbatcrazy",
            "game_id": "1896",
            "name": "Fruitbat Crazy",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_fruitbatcrazy.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_takethebank",
            "game_id": "2203",
            "name": "Take The Bank",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_takethebank-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_dragonphoenix",
            "game_id": "2515",
            "name": "Dragon & Phoenix",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_dragonphoenix.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_supersweets",
            "game_id": "2725",
            "name": "Super Sweets",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_supersweets.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_totaloverdrive",
            "game_id": "2878",
            "name": "Total Overdrive",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/total-overdrive-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_springtails",
            "game_id": "3321",
            "name": "Spring Tails",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_springTails_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_monsterpop",
            "game_id": "3595",
            "name": "Monster Pop",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/monster-pop-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_backtovenus",
            "game_id": "3973",
            "name": "Back To Venus",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/BackToVenus_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bts_questtothewest",
            "game_id": "6431",
            "name": "Quest to the West",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/quest-of-the-west-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bts_thehive",
            "game_id": "6818",
            "name": "The Hive",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/the-hive-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_themystichive",
            "game_id": "8502",
            "name": "The Mystic Hive",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_themystichive-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_dimsumprize",
            "game_id": "8755",
            "name": "Dim Sum Prize",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/dim-sum-prize-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_primalhunt",
            "game_id": "8769",
            "name": "Primal Hunt",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/Primal_Hunt_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_bookofdarkness",
            "game_id": "9393",
            "name": "Book Of Darkness",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/book-of-darkness-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_milesbelhouseandthegearsoftime",
            "game_id": "9979",
            "name": "Miles Belhouse and the Gears of time ",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_milesbelhouseandthegearsoftime.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_takesantasshop",
            "game_id": "10017",
            "name": "Take Santa's Shop",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/TakeSantasShop_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_goldenhorns",
            "game_id": "10680",
            "name": "Golden Horns",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/golden-horns-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_takeolympus",
            "game_id": "10682",
            "name": "Take Olympus",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/take-olympus-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_stacked",
            "game_id": "10684",
            "name": "Stacked",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/stacked-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_safarisam2",
            "game_id": "11459",
            "name": "Safari Sam 2",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/SafariSam2_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_lavagold",
            "game_id": "11461",
            "name": "Lava Gold ™",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/lavagold-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_hattrickhero",
            "game_id": "11463",
            "name": "Hat Trick Hero ™",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/hat-trick-hero-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_mrmacau",
            "game_id": "11465",
            "name": "Mr Macau",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/mr-macau-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_junglestripes",
            "game_id": "11467",
            "name": "Jungle Stripes",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/jungle-stripes-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_wilddrops",
            "game_id": "13013",
            "name": "Wild Drops",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/WildDrops_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_88frenzyfortune",
            "game_id": "13015",
            "name": "88 Frenzy Fortune",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/88-frenzy-fortune-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "bst_7fortunefrenzy",
            "game_id": "13017",
            "name": "7 Fortune Frenzy",
            "product": "Betsoft",
            "url_thumb": "https://cdn.dreamcasino.live/bst_7fortunefrenzy.jpg"
        }
    ],
    "SlotsPragmatic": [
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_moneymouse",
            "game_id": "3337",
            "name": "Money Mouse",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_moneymouse.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_aztecgems",
            "game_id": "3338",
            "name": "Aztec Gems",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/aztec-gems-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_5lionsgold",
            "game_id": "3339",
            "name": "5 Lions Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/5-lions-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_888dragons",
            "game_id": "3340",
            "name": "888 Dragons",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/888-Dragons.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wolfgold",
            "game_id": "3341",
            "name": "Wolf Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/wolf-gold-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_treeofriches",
            "game_id": "3342",
            "name": "Tree of Riches",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_treeofriches.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_sweetbonanza",
            "game_id": "3343",
            "name": "Sweet Bonanza",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_sweetbonanza.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_firestrike",
            "game_id": "3344",
            "name": "Fire Strike",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_firestrike.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_caishenscash",
            "game_id": "3345",
            "name": "Caishen's Cash",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/caishen-cash-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_jokersjewels",
            "game_id": "3346",
            "name": "Joker's Jewels",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/joker-jewels-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_goldenbeauty",
            "game_id": "3347",
            "name": "Golden Beauty",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/GoldenBeauty_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_masterjoker",
            "game_id": "3348",
            "name": "Master Joker",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_masterjoker.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_super7s",
            "game_id": "3349",
            "name": "Super 7s ",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_super7s.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_releasethekraken",
            "game_id": "3350",
            "name": "Release the Kraken",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_releasethekraken.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_buffaloking",
            "game_id": "3351",
            "name": "Buffalo King",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_buffaloking.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_magicjourney",
            "game_id": "3352",
            "name": "Magic Journey",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_magicjourney.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_honeyhoneyhoney",
            "game_id": "3353",
            "name": "Honey Honey Honey",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_honeyhoneyhoney.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_superjoker",
            "game_id": "3354",
            "name": "Super Joker",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_superjoker.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_johnhunterandthetombofthescarabqueen",
            "game_id": "3355",
            "name": "John Hunter and the Tomb of the Scarab Queen",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_johnhunterandthetombofthescarabqueen.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_thegreatchickenescape",
            "game_id": "3356",
            "name": "The Great Chicken Escape",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_thegreatchickenescape.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_vampiresvswolves",
            "game_id": "3357",
            "name": "Vampires vs Wolves",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_vampiresvswolves.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hotchilli",
            "game_id": "3358",
            "name": "Hot Chilli",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_hotchilli.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_egyptianfortunes",
            "game_id": "3359",
            "name": "Egyptian Fortunes",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/egyptian-fortune-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_aztectreasure",
            "game_id": "3360",
            "name": "Aztec Treasure",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_aztectreasure.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_monkeywarrior",
            "game_id": "3361",
            "name": "Monkey Warrior",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_monkeywarrior.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_monkeymadness",
            "game_id": "3362",
            "name": "Monkey Madness",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/monkey-madness-thumb.jpg"
        },
        {
            "category": "Baccarat",
            "enabled": "true",
            "game_code": "pgp_dragontiger",
            "game_id": "3363",
            "name": "Dragon Tiger",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/dragon-tiger-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_triplejokers",
            "game_id": "3364",
            "name": "Triple Jokers",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_triplejokers.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildpixies",
            "game_id": "3365",
            "name": "Wild Pixies",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/wild-pixies-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_caishensgold",
            "game_id": "3366",
            "name": "Caishen's Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/caishens-gold-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_5lions",
            "game_id": "3367",
            "name": "5 Lions",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/5-lions-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pirategold",
            "game_id": "3368",
            "name": "Pirate Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pirate-gold-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_goldenpig",
            "game_id": "3369",
            "name": "Golden Pig",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_goldenpig.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_treasurehorse",
            "game_id": "3370",
            "name": "Treasure Horse",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/treasure-horse-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_thedoghouse",
            "game_id": "3371",
            "name": "The Dog House",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/the-dog-house-thumb.jpg"
        },
        {
            "category": "Blackjack",
            "enabled": "true",
            "game_code": "pgp_americanblackjack",
            "game_id": "3372",
            "name": "American Blackjack",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_americanblackjack.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_luckynewyear",
            "game_id": "3373",
            "name": "Lucky New Year",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/lucky-new-year-thumb.jpg"
        },
        {
            "category": "Blackjack",
            "enabled": "true",
            "game_code": "pgp_multihandblackjack",
            "game_id": "3374",
            "name": "Multihand Blackjack",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_multihandblackjack.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_tripletigers",
            "game_id": "3375",
            "name": "Triple Tigers",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/triple-tigers-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_journeytothewest",
            "game_id": "3376",
            "name": "Journey to the West",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Journey-To-The-West-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_greatrhino",
            "game_id": "3377",
            "name": "Great Rhino",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/great-rhino-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_888gold",
            "game_id": "3378",
            "name": "888 Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_888gold.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_mustanggold",
            "game_id": "3379",
            "name": "Mustang Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/mustang-gold-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_fire88",
            "game_id": "3380",
            "name": "Fire 88",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/fire-88-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_8dragons",
            "game_id": "3381",
            "name": "8 Dragons",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/8-Dragons.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_dragonkingdom",
            "game_id": "3382",
            "name": "Dragon Kingdom",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Dragon-Kingdom-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_chilliheat",
            "game_id": "3383",
            "name": "Chilli Heat",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/chilli-heat-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildspells",
            "game_id": "3384",
            "name": "Wild Spells",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/wild-spells-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_diamondstrike",
            "game_id": "3385",
            "name": "Diamond Strike",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/diamond-strike-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_3kingdoms-battleofredcliffs",
            "game_id": "3386",
            "name": "3 Kingdoms - Battle of Red Cliffs",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/3-kingdoms-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pixiewings",
            "game_id": "3387",
            "name": "Pixie Wings",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pixie-wings-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_asgard",
            "game_id": "3388",
            "name": "Asgard",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/asgard-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_masterchensfortune",
            "game_id": "3389",
            "name": "Master Chen's Fortune",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_masterchensfortune-thumb.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pandasfortune",
            "game_id": "3390",
            "name": "Panda's Fortune",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/panda-fortune-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_tripledragons",
            "game_id": "3391",
            "name": "Triple Dragons",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_tripledragons.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pekingluck",
            "game_id": "3392",
            "name": "Peking Luck",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/peking-luck-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_moneyroll",
            "game_id": "3393",
            "name": "Money Roll",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_moneyroll.png"
        },
        {
            "category": "Baccarat",
            "enabled": "true",
            "game_code": "pgp_baccarat",
            "game_id": "3394",
            "name": "Baccarat",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_baccarat.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_goldrush",
            "game_id": "3395",
            "name": "Gold Rush",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/gold-rush-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_mightykong",
            "game_id": "3396",
            "name": "Mighty Kong",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Mighty-Kong-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_vegasmagic",
            "game_id": "3397",
            "name": "Vegas Magic",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/vegas-magic-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_7piggies",
            "game_id": "3398",
            "name": "7 Piggies",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/7-piggies-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_leprechauncarol",
            "game_id": "3399",
            "name": "Leprechaun Carol",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/leprechaun-carol-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_3geniewishes",
            "game_id": "3400",
            "name": "3 Genie Wishes",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/3-Genie-Wishes-Progmatic-logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_dwarvengolddeluxe",
            "game_id": "3401",
            "name": "Dwarven Gold Deluxe",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Dwarven-Gold-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_vegasnights",
            "game_id": "3402",
            "name": "Vegas Nights",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/vegas-nights-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hotsafari",
            "game_id": "3403",
            "name": "Hot Safari",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Hot-Safari-Pragmatic-Logo.jpg"
        },
        {
            "category": "Roulette",
            "enabled": "true",
            "game_code": "pgp_roulette",
            "game_id": "3404",
            "name": "Roulette",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_roulette.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_jadebutterfly",
            "game_id": "3405",
            "name": "Jade Butterfly",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/jade-butterfly-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_ladygodiva",
            "game_id": "3406",
            "name": "Lady Godiva",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Lady-Godiva-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_santa",
            "game_id": "3407",
            "name": "Santa",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/santa-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_ancientegyptclassic",
            "game_id": "3408",
            "name": "Ancient Egypt Classic",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/ancient-egypt-classic-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_luckydragons",
            "game_id": "3409",
            "name": "Lucky Dragons",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Lucky-Dragons-Logo.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_fairytalefortune",
            "game_id": "3410",
            "name": "Fairytale Fortune",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/fairytale-fortune-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_busybees",
            "game_id": "3411",
            "name": "Busy Bees",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_busybees.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_davincistreasure",
            "game_id": "3413",
            "name": "Da Vinci's Treasure",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/davincis-treasure-thumb.jpg"
        },
        {
            "category": "Video Poker",
            "enabled": "true",
            "game_code": "pgp_jacksorbetter",
            "game_id": "3414",
            "name": "Jacks or Better",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_jacksorbetter.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_diamondsareforever3lines",
            "game_id": "3415",
            "name": "Diamonds are Forever 3 Lines",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_diamondsareforever3lines.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_safariking",
            "game_id": "3416",
            "name": "Safari King",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/safariking-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_goldtrain",
            "game_id": "3417",
            "name": "Gold Train",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Gold-Train.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_irishcharms",
            "game_id": "3418",
            "name": "Irish Charms",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_irishcharms.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_7monkeys",
            "game_id": "3419",
            "name": "7 Monkeys",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/7-Monkeys-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_herculessonofzeus",
            "game_id": "3420",
            "name": "Hercules Son of Zeus",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Hercules-Pragmatic-Play-icon.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_beowulf",
            "game_id": "3421",
            "name": "Beowulf",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Beowulf-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildgladiator",
            "game_id": "3422",
            "name": "Wild Gladiator",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/wild-gladiators-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_sugarrush",
            "game_id": "3423",
            "name": "Sugar Rush",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Sugar-Rush-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_ladyofthemoon",
            "game_id": "3424",
            "name": "Lady of the Moon",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_ladyofthemoon.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_ancientegypt",
            "game_id": "3425",
            "name": "Ancient Egypt",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/ancient-egypt-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pantherqueen",
            "game_id": "3427",
            "name": "Panther Queen",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/panther-queen-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_queenofgold",
            "game_id": "3428",
            "name": "Queen of Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Queen-of-Gold-Pragmatic-logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_aladdinstreasure",
            "game_id": "3429",
            "name": "Aladdin's Treasure",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_aladdinstreasure.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_madamedestiny",
            "game_id": "3430",
            "name": "Madame Destiny",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/madame-destiny-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_jurassicgiants",
            "game_id": "3431",
            "name": "Jurassic Giants",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Jurassic-giants.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_magiccrystals",
            "game_id": "3432",
            "name": "Magic Crystals",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Magic-Crystals-Pragmatic-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_extrajuicy",
            "game_id": "3434",
            "name": "Extra Juicy",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/extra-juicy-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_queenofatlantis",
            "game_id": "3435",
            "name": "Queen of Atlantis",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Queen-of-Atlantis-Logo.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_leprechaunsong",
            "game_id": "3436",
            "name": "Leprechaun Song",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/leprechaun-song-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_greatreef",
            "game_id": "3438",
            "name": "Great Reef",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_greatreef.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_thechampions",
            "game_id": "3439",
            "name": "The Champions",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/the-champions-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_gloriousrome",
            "game_id": "3440",
            "name": "Glorious Rome",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_gloriousrome.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_dwarvengold",
            "game_id": "3441",
            "name": "Dwarven Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_dwarvengold.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_talesofegypt",
            "game_id": "3443",
            "name": "Tales of Egypt",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_talesofegypt.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_romeoandjuliet",
            "game_id": "3444",
            "name": "Romeo and Juliet",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_romeoandjuliet.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_devils13",
            "game_id": "3446",
            "name": "Devil's 13",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_devils13.png"
        },
        {
            "category": "Baccarat",
            "enabled": "true",
            "game_code": "pgp_dragonbonusbaccarat",
            "game_id": "3450",
            "name": "Dragon Bonus Baccarat",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_dragonbonusbaccarat.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wolfgold1000000",
            "game_id": "3454",
            "name": "Wolf Gold 1,000,000",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_wolfgold1000000.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hotsafari75000",
            "game_id": "3455",
            "name": "Hot Safari 75,000",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_hotsafari75000.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_queenofgold100000",
            "game_id": "3456",
            "name": "Queen of Gold 100,000",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_queenofgold100000.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pandagold50000",
            "game_id": "3457",
            "name": "Panda Gold 50,000",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_pandagold50000.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_diamondstrike250000",
            "game_id": "3459",
            "name": "Diamond Strike 250,000",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_diamondstrike250000.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_7piggies25000",
            "game_id": "3460",
            "name": "7 Piggies 25,000",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_7piggies25000.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_aladdinandthesorcerer",
            "game_id": "3461",
            "name": "Aladdin and the Sorcerer",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_aladdinandthesorcerer.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_greekgods",
            "game_id": "3462",
            "name": "Greek Gods",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_greekgods.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_herculesandpegasus",
            "game_id": "3463",
            "name": "Hercules and Pegasus",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_herculesandpegasus.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_sweetbonanzaxmas",
            "game_id": "3464",
            "name": "Sweet Bonanza Xmas",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_sweetbonanzaxmas_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_mysterious",
            "game_id": "3473",
            "name": "Mysterious",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_mysterious.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_aztecbonanza",
            "game_id": "3538",
            "name": "Aztec Bonanza",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_aztecbonanza.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_thewildmachine",
            "game_id": "3550",
            "name": "The Wild Machine",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/TheWildMachine_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_fruitrainbow",
            "game_id": "3569",
            "name": "Fruit Rainbow",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/fruil-rainbow-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_luckydragonball",
            "game_id": "3696",
            "name": "Lucky Dragon Ball",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_luckydragonball.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildwestgold",
            "game_id": "3704",
            "name": "Wild West Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/wild-west-gold-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_danceparty",
            "game_id": "3934",
            "name": "Dance Party",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/dance-party-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_greatrhinomegaways",
            "game_id": "3956",
            "name": "Great Rhino Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/GreatRhinoMegaways_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hottoburn",
            "game_id": "3957",
            "name": "Hot to Burn",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_hottoburn.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_threestarfortune",
            "game_id": "4003",
            "name": "Three Star Fortune",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_threestarfortune.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_bookoftut",
            "game_id": "4080",
            "name": "Book of Tut",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_bookoftut.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_starzmegaways",
            "game_id": "6542",
            "name": "Starz Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/starz-megaways-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_fruitparty",
            "game_id": "6544",
            "name": "Fruit Party",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/fruit-party-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_ultraburn",
            "game_id": "6558",
            "name": "Ultra Burn",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/ultra-burnthumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pyramidking",
            "game_id": "6596",
            "name": "Pyramid King",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pyramid-king-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_broncospirit",
            "game_id": "6814",
            "name": "Bronco Spirit",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/BroncoSpirit_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_dragojewelsoffortune",
            "game_id": "6824",
            "name": "Drago Jewels of Fortune",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/drago-Jewels-oflfortune-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_streetracer",
            "game_id": "6947",
            "name": "Street Racer",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/StreetRacer_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_greatrhinodeluxe",
            "game_id": "6977",
            "name": "Great Rhino Deluxe",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Great_Rhino_Deluxe_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_tigerwarrior",
            "game_id": "7145",
            "name": "Tiger Warrior",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/TigerWarrior_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_junglegorilla",
            "game_id": "7302",
            "name": "Jungle Gorilla™",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/JungleGorilla_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_thedoghousemegaways",
            "game_id": "7312",
            "name": "The Dog House Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/rlx_thedoghousemegaways-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_aztecgemsdeluxe",
            "game_id": "7314",
            "name": "Aztec Gems Deluxe",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_aztecgemsdeluxe.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_curseofthewerewolfmegaways",
            "game_id": "8452",
            "name": "Curse of the Werewolf Megaways™",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Curse_of_the_werewolf_megaways_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_ultraholdandspin",
            "game_id": "8623",
            "name": "Ultra Hold and Spin™",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/ultra-hold-spin-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_starbounty",
            "game_id": "8709",
            "name": "Star Bounty",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/StarBounty_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_5lionsdance",
            "game_id": "8735",
            "name": "5 Lions Dance",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/5LionsDance_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_riseofsamurai",
            "game_id": "8747",
            "name": "Rise of Samurai",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/rise-of-samurai-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildwalker",
            "game_id": "8761",
            "name": "Wild Walker",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Wild_Waker_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_gemsbonanza",
            "game_id": "8779",
            "name": "Gems Bonanza",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/gems-bonanza-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_returnofthedead",
            "game_id": "9206",
            "name": "Return of the Dead",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Return_of_the_Dead_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_emeraldking",
            "game_id": "9222",
            "name": "Emerald King",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/Emerald_King_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pirategolddeluxe",
            "game_id": "10075",
            "name": "Pirate Gold Deluxe",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pirate-gold-deluxe-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_thedragontiger",
            "game_id": "10110",
            "name": "The Dragon Tiger",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/dragon-tiger-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_bookofkingdoms",
            "game_id": "10340",
            "name": "Book Of Kingdoms",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_bookOfkingdoms_thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_christmascarolmegaways",
            "game_id": "10348",
            "name": "Christmas Carol Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_aChristmasCarolMegaways_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_spartanking",
            "game_id": "10446",
            "name": "Spartan King",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/SpartanKing_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_bigbassbonanzatm",
            "game_id": "10448",
            "name": "Big Bass Bonanza TM",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/BigBassBonanza_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_johnhunterandthemayangodstm",
            "game_id": "10450",
            "name": "John Hunter and the Mayan Gods",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_john-the-hunter-and-mayan-gods-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_cowboysgold",
            "game_id": "11033",
            "name": "Cowboys Gold",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_CowboysGold_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_voodoomagic",
            "game_id": "11062",
            "name": "Voodoo Magic",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_voodoo-magic-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_goldenox",
            "game_id": "11063",
            "name": "Golden Ox",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_golden-ox-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_mysteriousegypt",
            "game_id": "11064",
            "name": "Mysterious Egypt",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/mysterious-egypt-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_emeraldkingrainbowroad",
            "game_id": "11065",
            "name": "Emerald King Rainbow Road",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/emerald-king-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_congocash",
            "game_id": "11066",
            "name": "Congo Cash",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/congo-cash-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_madamedestinymegaways",
            "game_id": "11067",
            "name": "Madame Destiny Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_madamedestinymegaways.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_eyeofthestorm",
            "game_id": "11069",
            "name": "Eye of the Storm",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/eyeofthestorm-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_dragonkingdomeyesoffire",
            "game_id": "11071",
            "name": "Dragon Kingdom Eyes of Fire",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_dragonkingdomeyesoffire.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_handofmidas",
            "game_id": "11183",
            "name": "The Hand of Midas",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/TheHandOfMidas_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_jokerking",
            "game_id": "11185",
            "name": "Joker King",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/joker-king-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_gatesofolympus",
            "game_id": "11187",
            "name": "Gates of Olympus",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/GatesOfOlympus_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hottoburnholdandspin",
            "game_id": "11189",
            "name": "Hot to Burn Hold and Spin",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_hottoburnholdandspin.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_fishinreels",
            "game_id": "11191",
            "name": "Fishin' Reels",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/fishin-reels-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_temujintreasures",
            "game_id": "11193",
            "name": "Temujin Treasures",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/temujin-treasures-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_juicyfruits",
            "game_id": "11195",
            "name": "Juicy Fruits",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/JuicyFruits_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_bonanzagold",
            "game_id": "11580",
            "name": "Bonanza Gold™",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_bonanzagold.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildwildriches",
            "game_id": "11581",
            "name": "Wild Wild Riches",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/wild-wild-riches-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_drago-jewelsoffortune",
            "game_id": "11582",
            "name": "Drago - Jewels of Fortune",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_drago-jewelsoffortune.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_powerofthormegaways",
            "game_id": "11717",
            "name": "Power of Thor Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/power-of-thor-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_wildbooster",
            "game_id": "12647",
            "name": "Wild Booster",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_wild-booster-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_phoenixforge",
            "game_id": "12724",
            "name": "Phoenix Forge",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/phoenicforge-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_cashelevator",
            "game_id": "12726",
            "name": "Cash Elevator",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/cashelevator-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_themagiccauldronenchantedbrew",
            "game_id": "12736",
            "name": "The Magic Cauldron Enchanted Brew",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/the-magic-cauldron-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hotfiesta",
            "game_id": "12795",
            "name": "Hot Fiesta",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/hot-fiesta-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_amazingmoneymachine",
            "game_id": "12820",
            "name": "Amazing Money Machine",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/amazingmoneymachine-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_buffalokingmegaways",
            "game_id": "12857",
            "name": "Buffalo King Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/buffalo-king-megaways-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_floatingdragon",
            "game_id": "12912",
            "name": "Floating Dragon",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/floating-dragon-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_dragonhotholdandspin",
            "game_id": "12985",
            "name": "Dragon Hot Hold and Spin",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/DragonHotHoldAndSpin_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_pandafortune2",
            "game_id": "12997",
            "name": "Panda's Fortune 2",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pandafortune2-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_heartofrio",
            "game_id": "13002",
            "name": "Heart of Rio",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/HeartOfRio_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_luckylightning",
            "game_id": "13004",
            "name": "Lucky Lightning",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_luckylightning.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_riseofsamuraimegaways",
            "game_id": "13009",
            "name": "Rise of Samurai Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/RiseOfSamuraiMegaways_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_hokkaidowolf",
            "game_id": "13011",
            "name": "Hokkaido Wolf",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_hokkaidowolf.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_5lionsmegaways",
            "game_id": "13316",
            "name": "5 Lions Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_5lionsmegaways-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_emptythebank",
            "game_id": "13618",
            "name": "Empty the Bank",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_emptythebank.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_fruitparty2",
            "game_id": "13626",
            "name": "Fruit Party 2",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/FruitParty2_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_chickendrop",
            "game_id": "13665",
            "name": "Chicken Drop",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/chickendrop-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_riseofgizapowernudge",
            "game_id": "13667",
            "name": "Rise of Giza PowerNudge",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_riseofgizapowernudge.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_chilliheatmegaways",
            "game_id": "13669",
            "name": "Chilli Heat Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/chilly-heat-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_yumyumpowerways",
            "game_id": "13671",
            "name": "Yum Yum Powerways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/YmYumPowerways_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_azteckingmegaways",
            "game_id": "13678",
            "name": "Aztec King Megaways",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/pgp_azteckingmegaways.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "pgp_luckygracecharm",
            "game_id": "13923",
            "name": "Lucky, Grace & Charm",
            "product": "Pragmatic Play",
            "url_thumb": "https://cdn.dreamcasino.live/lucky-grace-and-charm-thumbnail.jpg"
        }
    ],
    "SlotsEvoplay": [
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_egyptgods",
            "game_id": "7880",
            "name": "Egypt Gods",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_egyptgods.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_luckymahjongbox",
            "game_id": "7882",
            "name": "Lucky Mahjong Box",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_luckymahjongbox.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_basketball",
            "game_id": "7884",
            "name": "Basketball",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_basketball.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_talismansoffortune",
            "game_id": "7886",
            "name": "Talismans of Fortune",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_talismansoffortune.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_thegreatwalltreasure",
            "game_id": "7888",
            "name": "The Great Wall Treasure",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_thegreatwalltreasure.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_robinhood",
            "game_id": "7890",
            "name": "Robin Hood",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_robinhood.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_chinesenewyear",
            "game_id": "7892",
            "name": "Chinese New Year",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_chinesenewyear.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_clashofpirates",
            "game_id": "7894",
            "name": "Clash of Pirates",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_clashofpirates.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_journeytothewest",
            "game_id": "7896",
            "name": "Journey to the West",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_journeytothewest.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_thelegendofshaolin",
            "game_id": "7898",
            "name": "The Legend of Shaolin",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_thelegendofshaolin.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_vegasnights",
            "game_id": "7900",
            "name": "Vegas Nights",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_vegasnights.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_jewellerystore",
            "game_id": "7902",
            "name": "Jewellery Store",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_jewellerystore.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_redcliff",
            "game_id": "7904",
            "name": "Red Cliff",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_redcliff.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_indianasquest",
            "game_id": "7906",
            "name": "Indiana's Quest",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_indianasquest.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_aceround",
            "game_id": "7908",
            "name": "Ace Round",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_aceround.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_elvenprincesses",
            "game_id": "7910",
            "name": "Elven Princesses",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_elvenprincesses.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fruitburst",
            "game_id": "7912",
            "name": "Fruit Burst",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fruitburst.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_football",
            "game_id": "7914",
            "name": "Football",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_football.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_legendofra",
            "game_id": "7916",
            "name": "Legend of Ra",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_legendofra.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_theemperorstomb",
            "game_id": "7918",
            "name": "The Emperor's Tomb",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_theemperorstomb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_necromancer",
            "game_id": "7920",
            "name": "Necromancer",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_necromancer.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_naughtygirlscabaret",
            "game_id": "7922",
            "name": "Naughty Girls Cabaret",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_naughtygirlscabaret.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_atlantis",
            "game_id": "7924",
            "name": "Atlantis",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_atlantis.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_epicgladiators",
            "game_id": "7926",
            "name": "Epic Gladiators",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_epicgladiators.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_sindbad",
            "game_id": "7928",
            "name": "Sindbad",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_sindbad.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_totemisland",
            "game_id": "7930",
            "name": "Totem Island",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_totemisland.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_robinson",
            "game_id": "7932",
            "name": "Robinson",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_robinson.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_candydreams",
            "game_id": "7934",
            "name": "Candy Dreams",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_candydreams.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_rollthedice",
            "game_id": "7936",
            "name": "Roll The Dice",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_rollthedice.png"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_headstails",
            "game_id": "7938",
            "name": "Heads & Tails",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_headstails.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_moreorless",
            "game_id": "7940",
            "name": "More or Less",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_moreorless.jpg"
        },
        {
            "category": "Blackjack",
            "enabled": "true",
            "game_code": "evp_blackjackluckysevens",
            "game_id": "7942",
            "name": "BlackJack Lucky Sevens",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_blackjackluckysevens.jpg"
        },
        {
            "category": "Poker",
            "enabled": "true",
            "game_code": "evp_oasispokerclassic",
            "game_id": "7944",
            "name": "Oasis Poker Classic",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_oasispokerclassic.jpg"
        },
        {
            "category": "Poker",
            "enabled": "true",
            "game_code": "evp_oasispokerproseries",
            "game_id": "7946",
            "name": "Oasis Poker Pro Series",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_oasispokerproseries.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_ussrseventies",
            "game_id": "7948",
            "name": "USSR Seventies",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_ussrseventies.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_theslavs",
            "game_id": "7950",
            "name": "The Slavs",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_theslavs.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_fouraces",
            "game_id": "7952",
            "name": "Four Aces",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fouraces.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_redqueen",
            "game_id": "7954",
            "name": "Red Queen",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_redqueen.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_thimbles",
            "game_id": "7956",
            "name": "Thimbles",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_thimbles.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_aeronauts",
            "game_id": "7958",
            "name": "Aeronauts",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_aeronauts.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_prohibition",
            "game_id": "7960",
            "name": "Prohibition",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_prohibition.jpg"
        },
        {
            "category": "Roulette",
            "enabled": "true",
            "game_code": "evp_europeanroulette",
            "game_id": "7962",
            "name": "European Roulette",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_europeanroulette.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_monsterlab",
            "game_id": "7964",
            "name": "Monster Lab",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_monsterlab.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_thegreatconflict",
            "game_id": "7966",
            "name": "The Great Conflict",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_thegreatconflict.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_battletanks",
            "game_id": "7968",
            "name": "Battle Tanks",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_battletanks.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_dolphinstreasure",
            "game_id": "7970",
            "name": "Dolphins Treasure",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_dolphinstreasure.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_ussrgrocery",
            "game_id": "7972",
            "name": "USSR Grocery",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_ussrgrocery.jpg"
        },
        {
            "category": "Baccarat",
            "enabled": "true",
            "game_code": "evp_baccarat777",
            "game_id": "7974",
            "name": "Baccarat 777",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_baccarat777.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_mysteryplanet",
            "game_id": "7976",
            "name": "Mystery Planet",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_mysteryplanet.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fruitsland",
            "game_id": "7978",
            "name": "Fruits Land",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fruitsland.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_charmingqueens",
            "game_id": "7980",
            "name": "Charming Queens",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_charmingqueens.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_luckygirls",
            "game_id": "7982",
            "name": "Lucky Girls",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_luckygirls.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_rockpaperscissors",
            "game_id": "7984",
            "name": "Rock Paper Scissors",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_rockpaperscissors.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_robotsenergyconflict",
            "game_id": "7988",
            "name": "Robots: Energy Conflict",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_robotsenergyconflict.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_syndicate",
            "game_id": "7990",
            "name": "Syndicate",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_syndicate.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_triptothefuture",
            "game_id": "7992",
            "name": "Trip to the Future",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_triptothefuture.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_etlostsocks",
            "game_id": "7994",
            "name": "E.T. Lost Socks",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_etlostsocks.jpg"
        },
        {
            "category": "Roulette",
            "enabled": "true",
            "game_code": "evp_americanroulette3dclassic",
            "game_id": "7996",
            "name": "American Roulette 3D Classic",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_americanroulette3dclassic.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_etraces",
            "game_id": "7998",
            "name": "E.T. Races",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_etraces.jpg"
        },
        {
            "category": "Multiplayer",
            "enabled": "true",
            "game_code": "evp_highstriker",
            "game_id": "8000",
            "name": "High Striker",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_highstriker.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_nukeworld",
            "game_id": "8004",
            "name": "Nuke World",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_nukeworld.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_reignofdragons",
            "game_id": "8006",
            "name": "Reign of Dragons",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_reignofdragons.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_dungeon",
            "game_id": "8008",
            "name": "Dungeon",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_dungeon.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_sprinkle",
            "game_id": "8010",
            "name": "Sprinkle",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_sprinkle.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_brutalsanta",
            "game_id": "8012",
            "name": "Brutal Santa",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_brutalsanta.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_maze",
            "game_id": "8014",
            "name": "Maze",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_maze.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_legendofkaan",
            "game_id": "8016",
            "name": "Legend of Kaan",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_legendofkaan.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_hungrynight",
            "game_id": "8018",
            "name": "Hungry Night",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_hungrynight.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_couriersweeper",
            "game_id": "8020",
            "name": "Courier Sweeper",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_couriersweeper.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_scratchmatch",
            "game_id": "8022",
            "name": "Scratch Match",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_scratchmatch.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_bookofrest",
            "game_id": "8024",
            "name": "Book of Rest",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_bookofrest.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_hottriplesevens",
            "game_id": "8026",
            "name": "Hot Triple Sevens",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_hottriplesevens.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_magicwheel",
            "game_id": "8028",
            "name": "Magic Wheel",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_magicwheel.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_bombsquad",
            "game_id": "8030",
            "name": "Bomb Squad",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_bombsquad.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_seasonsisters",
            "game_id": "8032",
            "name": "Season sisters",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_seasonsisters.png"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_mafiasyndicate",
            "game_id": "8034",
            "name": "Mafia Syndicate",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_mafiasyndicate.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_animalquest",
            "game_id": "8036",
            "name": "Animal Quest",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_animalquest.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_richreels",
            "game_id": "8038",
            "name": "Rich Reels",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_richreels.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_irishreels",
            "game_id": "8040",
            "name": "Irish Reels",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_irishreels.jpg"
        },
        {
            "category": "Poker",
            "enabled": "true",
            "game_code": "evp_texasholdempoker",
            "game_id": "8042",
            "name": "Texas Holdem Poker",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_texasholdempoker.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_riseofhorus",
            "game_id": "8044",
            "name": "Rise Of Horus",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_riseofhorus.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_minefield",
            "game_id": "8046",
            "name": "Mine Field",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_minefield.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_crownandanchor",
            "game_id": "8048",
            "name": "Crown and Anchor",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_crownandanchor.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_westernreels",
            "game_id": "8050",
            "name": "Western Reels",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_westernreels.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_rocketstars",
            "game_id": "8052",
            "name": "Rocket Stars",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_rocketstars.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fluffyrangers",
            "game_id": "8054",
            "name": "Fluffy Rangers",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fluffyrangers.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_penaltyshootout",
            "game_id": "8056",
            "name": "Penalty Shoot Out",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_penaltyshootout.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_midnightshow",
            "game_id": "8058",
            "name": "Midnight Show",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_midnightshow.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_explodingfruits",
            "game_id": "8060",
            "name": "Exploding Fruits",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_explodingfruits.jpg"
        },
        {
            "category": "Roulette",
            "enabled": "true",
            "game_code": "evp_frenchrouletteclassic",
            "game_id": "8062",
            "name": "French Roulette Classic",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_frenchrouletteclassic.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_seaofspins",
            "game_id": "8064",
            "name": "Sea of Spins",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_seaofspins.png"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_surfzone",
            "game_id": "8066",
            "name": "Surf Zone",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_surfzone.png"
        },
        {
            "category": "Unknown",
            "enabled": "true",
            "game_code": "evp_texasholdembonus",
            "game_id": "8068",
            "name": "Texas Holdem Bonus",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_texasholdembonus.png"
        },
        {
            "category": "Unknown",
            "enabled": "true",
            "game_code": "evp_footballmanager",
            "game_id": "8070",
            "name": "Football Manager",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_footballmanager.jpg"
        },
        {
            "category": "Poker",
            "enabled": "true",
            "game_code": "evp_indianpoker",
            "game_id": "8214",
            "name": "Indian Poker",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_pokerteenpatti.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_jellyboom",
            "game_id": "8619",
            "name": "Jelly Boom",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_jellyboom.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_forestdreams",
            "game_id": "8677",
            "name": "Forest Dreams",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_forestdreams.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_raccoontales",
            "game_id": "8932",
            "name": "Raccoon Tales",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_raccoontales.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_wheeloftime",
            "game_id": "8977",
            "name": "Wheel of Time",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_wheeloftime-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_forgottenfable",
            "game_id": "9018",
            "name": "Forgotten Fable",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_forgottenfable-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_jollytreasures",
            "game_id": "9079",
            "name": "Jolly Treasures",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/jolly-treasures-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_nightofthelivingtales",
            "game_id": "9158",
            "name": "Night of the living Tales",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/Night_of_the_Living_Tales_thumb.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_bookofkeno",
            "game_id": "9385",
            "name": "Book of Keno",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/book-of-keno-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_icemania",
            "game_id": "9407",
            "name": "Ice Mania",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/ice-mania-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_valleyofdreams",
            "game_id": "9419",
            "name": "Valley of Dreams",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/valley-of-dreams-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fruitnova",
            "game_id": "10305",
            "name": "Fruit Nova",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fruit_nova_thumb.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_pachingirl",
            "game_id": "10405",
            "name": "Pachin Girl",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/PachinGirl_Thumbnail.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_christmasparty",
            "game_id": "10407",
            "name": "Christmas Party",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_christmas-party-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_treeoflight",
            "game_id": "10409",
            "name": "Tree of Light",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/tree-of-light-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_xmaskenocat",
            "game_id": "10411",
            "name": "Xmas Keno Cat",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/XmasKenoCat_Thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_wildbullet",
            "game_id": "10413",
            "name": "Wild Bullet",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/Wild_Bullet_thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_treasuremania",
            "game_id": "10415",
            "name": "Treasure Mania",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/treasure-mania-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_templeofdead",
            "game_id": "11055",
            "name": "Temple of Dead",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/temple-of-dead-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fruitsupernova",
            "game_id": "11057",
            "name": "Fruit Super Nova",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_fruitsupernova.jpg"
        },
        {
            "category": "Instant Win Games",
            "enabled": "true",
            "game_code": "evp_mysteriesoftheeast",
            "game_id": "11197",
            "name": "Mysteries of the East",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/mysteriesofthe-east-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_epiclegends",
            "game_id": "11199",
            "name": "Epic Legends",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/epic-legends-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_unlimitedwishes",
            "game_id": "11201",
            "name": "Unlimited Wishes",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/unlimited-wishes-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_ellensfortune",
            "game_id": "11203",
            "name": "Ellen's Fortune",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/ellens-fortune-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_runesofdestiny",
            "game_id": "11205",
            "name": "Runes of Destiny",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/runes-of-destiny-thumb.jpg"
        },
        {
            "category": "Instant Win Games",
            "enabled": "true",
            "game_code": "evp_mehen",
            "game_id": "11207",
            "name": "Mehen",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_mehen.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_sweetsugar",
            "game_id": "12276",
            "name": "Sweet Sugar",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/sweet-sugar-thumb.jpg"
        },
        {
            "category": "Instant Win Games",
            "enabled": "true",
            "game_code": "evp_rolltoluck",
            "game_id": "12280",
            "name": "Roll to Luck",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/roll-to-luck-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_foodfeast",
            "game_id": "12330",
            "name": "Food Feast",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/food-feast-thumbnail.jpg"
        },
        {
            "category": "Instant Win Games",
            "enabled": "true",
            "game_code": "evp_neonshapes",
            "game_id": "12369",
            "name": "Neon Shapes",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/neon-shapes-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_cycleofluck",
            "game_id": "12554",
            "name": "Cycle of Luck",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/cycleofluck-thumb.jpg"
        },
        {
            "category": "Instant Win Games",
            "enabled": "true",
            "game_code": "evp_luckysector",
            "game_id": "12556",
            "name": "Lucky Sector",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/LuckySector_Thumbnail.jpg"
        },
        {
            "category": "Casual Games",
            "enabled": "true",
            "game_code": "evp_plingoball",
            "game_id": "12558",
            "name": "PlingoBall",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/plingo-ball-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_gangsternight",
            "game_id": "12560",
            "name": "Gangster Night",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/gangster-night-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_goldofsirens",
            "game_id": "12562",
            "name": "Gold of Sirens",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_goldofsirens.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_bloodybrilliant",
            "game_id": "12564",
            "name": "Bloody Brilliant",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_bloodybrilliant-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_dungeonimmortalevil",
            "game_id": "13227",
            "name": "Dungeon: Immortal Evil",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/evp_dungeonimmortalevil-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fruitsupernova40",
            "game_id": "13700",
            "name": "Fruit Super Nova 40",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/fruit-super-nova-40-thumbnail.jpg"
        },
        {
            "category": "Instant Win Games",
            "enabled": "true",
            "game_code": "evp_bonanzawheel",
            "game_id": "13702",
            "name": "Bonanza Wheel",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/bonanza-wheel-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_templeofdeadbonusbuy",
            "game_id": "13704",
            "name": "Temple of Dead Bonus Buy",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/temple-of-dead-thumbnail.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_savethehamster",
            "game_id": "13708",
            "name": "Save the Hamster",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/savethehamster-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_shadowofluxor",
            "game_id": "13816",
            "name": "Shadow of Luxor",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/Shadow_of_Luxor-thumb.jpg"
        },
        {
            "category": "Video Slots",
            "enabled": "true",
            "game_code": "evp_fruitsupernova30",
            "game_id": "14206",
            "name": "Fruit Super Nova 30",
            "product": "Evoplay Entertainment",
            "url_thumb": "https://cdn.dreamcasino.live/FruitSuperNova30_Thumbnail.jpg"
        }
    ]
}
const __LOTUS_GAMES = [
    {
        GID: 228002,
        NAME: "32 Cards",
        IMG: "../../../assets/images/ezugi/32 Cards - 400x200.png"
    },
    {
        GID: 228000,
        NAME: "Andar Bahar",
        IMG: "../../../assets/images/ezugi/Andar Bahar - 400x200.png"
    },
    {
        GID: 100,
        NAME: "Baccarat",
        IMG: "../../../assets/images/ezugi/Baccarat - 400x200.png"
    },
    {
        GID: 602000,
        NAME: "Bet On Numbers",
        IMG: "../../../assets/images/ezugi/BON - 400x200.png"
    },
    {
        GID: 227101,
        NAME: "Bet on TeenPatti",
        IMG: "../../../assets/images/ezugi/Bet on Teen Patti_400x200.png"
    },
    {
        GID: 51,
        NAME: "Blackjack",
        IMG: "../../../assets/images/ezugi/Blackjack - 400x200.png"
    },
    {
        GID: 507000,
        NAME: "Casino Holdem",
        IMG: "../../../assets/images/ezugi/Casino Holdem - 400x200.png"
    },
    {
        GID: 45100,
        NAME: "Cricket War",
        IMG: "../../../assets/images/ezugi/Cricket War - 400x200.png"
    },
    {
        GID: 150,
        NAME: "Dragon Tiger",
        IMG: "../../../assets/images/ezugi/Dragon Tiger - 400x200.png"
    },
    {
        GID: 228001,
        NAME: "Lucky 7",
        IMG: "../../../assets/images/ezugi/Lucky 7 - 400x200.png"
    },
    {
        GID: 227103,
        NAME: "One Day Teenpatti",
        IMG: "../../../assets/images/ezugi/ODTPC_400x200.png"
    },
    {
        GID: 224000,
        NAME: "Ultimate Sic Bo",
        IMG: "../../../assets/images/ezugi/Ultimate Sic Bo_400x200.png"
    },
    {
        GID: 7100,
        NAME: "Teen Patti",
        IMG: "../../../assets/images/ezugi/Teen Patti_400x200.png"
    },
    {
        GID: 5001,
        NAME: "Auto Roulette",
        IMG: "../../../assets/images/ezugi/Auto Roulette_500x160.png"
    },
    {
        GID: 221002,
        NAME: "Auto Speed Roulette",
        IMG: "../../../assets/images/ezugi/Auto Speed Roulette - 220 x 145.png"
    },
    {
        GID: 205,
        NAME: "Blackjack Bucuresti",
        IMG: "../../../assets/images/ezugi/400x200_BJ_ro.png"
    },
    {
        GID: 204,
        NAME: "Blackjack Gold",
        IMG: "../../../assets/images/ezugi/Blackjack Gold - 400x200.png"
    },
    {
        GID: 227,
        NAME: "Blackjack Salon Prive",
        IMG: "../../../assets/images/ezugi/400x200_BJ_SALON.png"
    },
    {
        GID: 101,
        NAME: "Baccarat Cricket",
        IMG: "../../../assets/images/ezugi/baccarat cricket - 220x145.png"
    },
    {
        GID: 221003,
        NAME: "Diamond Roulette",
        IMG: "../../../assets/images/ezugi/Diamond Roulette.png"
    },
    {
        GID: 1000,
        NAME: "Italian Roulette",
        IMG: "../../../assets/images/ezugi/Italian Roulette - 400x200.png"
    },
    {
        GID: 221005,
        NAME: "Namaste Roulette",
        IMG: "../../../assets/images/ezugi/Namaste Roulette - 400x200.png"
    },
    {
        GID: 501000,
        NAME: "Turkce Roulette",
        IMG: "../../../assets/images/ezugi/Turkce Roulette - 400x200.png"
    },
    {
        GID: 102,
        NAME: "Fortune Baccarat",
        IMG: "../../../assets/images/ezugi/FortuneBaccarat.jpg"
    },
    {
        GID: 43100,
        NAME: "Fiesta Baccarat",
        IMG: "../../../assets/images/ezugi/Baccarat_Fiesta.jpg"
    },
    {
        GID: 120,
        NAME: "KnockOut Baccarat",
        IMG: "../../../assets/images/ezugi/BaccaratKnockOut.jpg"
    },
    {
        GID: 225,
        NAME: "Diamond VIP Blackjack",
        IMG: "../../../assets/images/ezugi/Blakjack_DV.jpg"
    },
    {
        GID: 224,
        NAME: "VIP Blackjack With Surrender",
        IMG: "../../../assets/images/ezugi/Blackjack_With_S.jpg"
    },
    {
        GID: 227103,
        NAME: "One Day TeenPatti",
        IMG: "../../../assets/images/ezugi/OneDayTeenPatti.jpg"
    },
    {
        GID: 601000,
        NAME: "Ruletka Russia",
        IMG: "../../../assets/images/ezugi/RuletkaRussia.jpg"
    },
    {
        GID: 431000,
        NAME: "Ruletka Del Sol",
        IMG: "../../../assets/images/ezugi/RouletteDelSol.png"
    },
    {
        GID: 328000,
        NAME: "OTT Andar Bahar",
        IMG: "../../../assets/images/ezugi/OTT_Andar_Bahar.jpg"
    },
    {
        GID: 170,
        NAME: "No Commision Baccarat",
        IMG: "../../../assets/images/ezugi/Bacarrat_no_Camission.jpg"
    },
    {
        GID: 130,
        NAME: "Baccarat Super Six",
        IMG: "../../../assets/images/ezugi/BaccaratSuper6.jpg"
    },
    {
        GID: 227100,
        NAME: "Teen Patti 3 Card",
        IMG: "../../../assets/images/ezugi/Teenpatti3Cards.jpg"
    },
    {
        GID: 425,
        NAME: "White Russia Blackjack",
        IMG: "../../../assets/images/ezugi/Blackjack_Wihte_Russian.jpg"
    },
    {
        GID: 4151,
        NAME: "Blackjack Mambo",
        IMG: "../../../assets/images/ezugi/Blackjack_Mambo.jpg"
    },
    {
        GID: 221004,
        NAME: "Prestige Auto Roulette",
        IMG: "../../../assets/images/ezugi/Prestige Auto Roulette - 400x200.png"
    },
    {
        GID: 611006,
        NAME: "Oracle Blaze Roulette",
        IMG: "../../../assets/images/ezugi/OracleRulet.jpg"
    },
    {
        GID: 611004,
        NAME: "Portomaso Real Casino Roulett",
        IMG: "../../../assets/images/ezugi/PortomasoCasino.jpg"
    },
    {
        GID: 426,
        NAME: "Black Russian Blackjack",
        IMG: "../../../assets/images/ezugi/BJ_BLACK_RUSSIAN.jpg"
    }
]
const __Casino_Ezugi_Games = [
    {
        GID: 201,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/blackjack/1.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack 1",
        TCODE: 100000,
        catagory: "Blackjack"
    },
    // {
    //     GID: 413,
    //     IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/blackjack/2.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
    //     Name: "Blackjack 3",
    //     TCODE: 100000
    // },
    {
        GID: 51,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/blackjack/51.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Unlimited Blackjack",
        TCODE: 100000,
        catagory: "Blackjack"
    },
    {
        GID: 1000,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/roulette/1000.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Italian roulette",
        TCODE: 100000,
        catagory: "Roulette"
    },
    {
        GID: 5001,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/roulette/5001.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Automatic roulette",
        TCODE: 100000,
        catagory: "Roulette"
    },
    {
        GID: 61100,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/roulette/611000.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Portomaso casino roulette",
        TCODE: 100000,
        catagory: "Roulette"
    },
    {
        GID: 100,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/baccarat/100.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Golden baccarat",
        TCODE: 100000,
        catagory: "Baccarat"
    },
    {
        GID: 130,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/baccarat/130.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Golden baccarat super six",
        TCODE: 100000,
        catagory: "Baccarat"
    },
    {
        GID: 170,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/baccarat/170.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "No commision baccarat",
        TCODE: 100000,
        catagory: "Baccarat"
    },
    {
        GID: 30100,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/baccarat/30100.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Marina Casino Baccarat 1",
        TCODE: 100000,
        catagory: "Baccarat"
    },
    {
        GID: 150,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/other/150.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Dragon tiger",
        TCODE: 100000,
        catagory: "Other"
    },
    {
        GID: 7000,
        IMGURL: "url(https://sitethemedata.com/casino_icons/ezugi/other/7000.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Casino Holde’m",
        TCODE: 100000,
        catagory: "Other"
    },
]
const __Casino_Evolution_Games = [
    {
        GID: 1000033,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000033.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack D",
        catagory: "Blackjack"
    },
    {
        GID: 1000034,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000034.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack E",
        catagory: "Blackjack"
    },
    {
        GID: 1000036,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000036.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack G",
        catagory: "Blackjack"
    },
    {
        GID: 1000037,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000037.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack H",
        catagory: "Blackjack"
    },
    {
        GID: 1000038,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000038.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack I",
        catagory: "Blackjack"
    },
    {
        GID: 1000039,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000039.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack J",
        catagory: "Blackjack"
    },
    {
        GID: 1000040,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000040.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Party",
        catagory: "Blackjack"
    },
    {
        GID: 1000041,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000041.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver A",
        catagory: "Blackjack"
    },
    {
        GID: 1000042,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000042.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver B",
        catagory: "Blackjack"
    },
    {
        GID: 1000043,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000043.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver C",
        catagory: "Blackjack"
    },
    {
        GID: 1000044,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000044.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver D",
        catagory: "Blackjack"
    },
    {
        GID: 1000045,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000045.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver E",
        catagory: "Blackjack"
    },
    {
        GID: 1000046,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000046.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver F",
        catagory: "Blackjack"
    },
    {
        GID: 1000047,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000047.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Silver G",
        catagory: "Blackjack"
    },
    {
        GID: 1000048,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000048.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip A",
        catagory: "Blackjack"
    },
    {
        GID: 1000049,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000049.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip B",
        catagory: "Blackjack"
    },
    {
        GID: 1000050,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000050.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip C",
        catagory: "Blackjack"
    },
    {
        GID: 1000051,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000051.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip D",
        catagory: "Blackjack"
    },
    {
        GID: 1000052,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000052.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip E",
        catagory: "Blackjack"
    },
    {
        GID: 1000053,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000053.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip G",
        catagory: "Blackjack"
    },
    {
        GID: 1000054,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000054.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip H",
        catagory: "Blackjack"
    },
    {
        GID: 1000056,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000056.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip L",
        catagory: "Blackjack"
    },
    {
        GID: 1000057,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000057.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip M",
        catagory: "Blackjack"
    },
    {
        GID: 1000058,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000058.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip O",
        catagory: "Blackjack"
    },
    {
        GID: 1000059,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000059.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip P",
        catagory: "Blackjack"
    },
    {
        GID: 1000060,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000060.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip R",
        catagory: "Blackjack"
    },
    {
        GID: 1000061,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000061.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip S",
        catagory: "Blackjack"
    },
    {
        GID: 1000062,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000062.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip T",
        catagory: "Blackjack"
    },
    {
        GID: 1000035,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000035.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack F",
        catagory: "Blackjack"
    },
    {
        GID: 1000063,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000063.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack White A",
        catagory: "Blackjack"
    },
    {
        GID: 1000064,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000064.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack White B",
        catagory: "Blackjack"
    },
    {
        GID: 1000065,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000065.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack White C",
        catagory: "Blackjack"
    },
    {
        GID: 1000068,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000068.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Blackjack A",
        catagory: "Blackjack"
    },
    {
        GID: 1000069,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000069.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Blackjack B",
        catagory: "Blackjack"
    },
    {
        GID: 1000070,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000070.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Blackjack C",
        catagory: "Blackjack"
    },
    {
        GID: 1000158,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000158.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Blackjack D",
        catagory: "Blackjack"
    },
    {
        GID: 1000159,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000159.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Blackjack E",
        catagory: "Blackjack"
    },
    {
        GID: 1000160,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000160.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Blackjack F",
        catagory: "Blackjack"
    },
    {
        GID: 1000132,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000132.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Blackjack A",
        catagory: "Blackjack"
    },
    {
        GID: 1000133,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000133.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Blackjack B",
        catagory: "Blackjack"
    },
    {
        GID: 1000134,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000134.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Blackjack C",
        catagory: "Blackjack"
    },
    {
        GID: 1000135,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000135.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Blackjack D",
        catagory: "Blackjack"
    },
    {
        GID: 1000119,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000119.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "First Person Blackjack",
        catagory: "Blackjack"
    },
    {
        GID: 1000066,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000066.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Free Bet Blackjack",
        catagory: "Blackjack"
    },
    {
        GID: 1000067,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000067.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Infinite Blackjack",
        catagory: "Blackjack"
    },
    {
        GID: 1000032,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000030.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack A",
        catagory: "Blackjack"
    },
    {
        GID: 1000032,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000031.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack B",
        catagory: "Blackjack"
    },
    {
        GID: 1000032,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000032.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack C",
        catagory: "Blackjack"
    },
    {
        GID: 1000130,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000130.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip Q",
        catagory: "Blackjack"
    },
    {
        GID: 1000055,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000055.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip I",
        catagory: "Blackjack"
    },
    {
        GID: 1000162,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000162.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip Alpha",
        catagory: "Blackjack"
    },
    {
        GID: 1000163,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000163.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip Betta",
        catagory: "Blackjack"
    },
    {
        GID: 1000164,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/blackjack/1000164.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Blackjack Vip Gamma",
        catagory: "Blackjack"
    },
    {
        GID: 1000354,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000354.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Hindi Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000123,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000123.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Auto-Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000126,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000126.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Auto-Roulette VIP",
        catagory: "Roulette"
    },
    {
        GID: 1000122,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000122.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Immersive Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000092,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000092.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Lightning Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000094,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000094.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000102,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000102.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000104,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000104.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000124,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000124.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "VIP Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000011,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/roulette/1000011.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "American Roulette",
        catagory: "Roulette"
    },
    {
        GID: 1000012,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000012.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Baccarat A",
        catagory: "Baccarat"
    },
    {
        GID: 1000013,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000013.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Baccarat B",
        catagory: "Baccarat"
    },
    {
        GID: 1000014,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000014.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Baccarat C",
        catagory: "Baccarat"
    },
    {
        GID: 1000015,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000015.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Baccarat Control Squeeze",
        catagory: "Baccarat"
    },
    {
        GID: 1000016,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000016.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Baccarat Squeeze",
        catagory: "Baccarat"
    },
    {
        GID: 1000017,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000017.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "No Comm Speed Baccarat",
        catagory: "Baccarat"
    },
    {
        GID: 1000018,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000018.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "No Commission Baccarat",
        catagory: "Baccarat"
    },
    {
        GID: 1000020,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000020.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Baccarat A",
        catagory: "Baccarat"
    },
    {
        GID: 1000127,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000127.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Baccarat B",
        catagory: "Baccarat"
    },
    {
        GID: 1000156,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000156.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Salon PrivÃ© Baccarat C",
        catagory: "Baccarat"
    },
    {
        GID: 1000021,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000021.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat A",
        catagory: "Baccarat"
    },
    {
        GID: 1000022,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000022.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat B",
        catagory: "Baccarat"
    },
    {
        GID: 1000023,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000023.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat C",
        catagory: "Baccarat"
    },
    {
        GID: 1000024,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000024.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat D",
        catagory: "Baccarat"
    },
    {
        GID: 1000025,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000025.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat E",
        catagory: "Baccarat"
    },
    {
        GID: 1000026,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000026.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat F",
        catagory: "Baccarat"
    },
    {
        GID: 1000027,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000027.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat G",
        catagory: "Baccarat"
    },
    {
        GID: 1000028,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000028.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat H",
        catagory: "Baccarat"
    },
    {
        GID: 1000029,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000029.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat I",
        catagory: "Baccarat"
    },
    {
        GID: 1000129,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/baccarat/1000129.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Speed Baccarat J",
        catagory: "Baccarat"
    },
    {
        GID: 1000074,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000074.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Dragon Tiger",
        catagory: "Other"
    },
    {
        GID: 1000110,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000110.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Super Sic Bo",
        catagory: "Other"
    },
    {
        GID: 1000077,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000077.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Dream Catcher",
        catagory: "Other"
    },
    {
        GID: 1000116,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000116.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Extreme Texas Hold'em",
        catagory: "Other"
    },
    {
        GID: 1000111,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000111.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Texas Hold'em Bonus Poker",
        catagory: "Other"
    },
    {
        GID: 1000112,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000112.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Football studio",
        catagory: "Other"
    },
    {
        GID: 1000071,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000071.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Caribbean Stud Poker",
        catagory: "Other"
    },
    {
        GID: 1000248,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000248.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "Craps",
        catagory: "Other"
    },
    {
        GID: 1000249,
        IMGURL: "url(https://sitethemedata.com/casino_icons/evo/other/1000249.jpg), url(https://wver.sprintstaticdata.com/v14/static/front/img/casino/default-2.jpeg)",
        Name: "RNG Craps",
        catagory: "Other"
    },
]
export { commonURI, fTradeApi, deleteTradeApi, commonUriAll, _DREAM_CASINO_GAMES, __LOTUS_LOBBY, __Casino_Evolution_Games, __Casino_Ezugi_Games, __WebKeyUSER }